/*
 * angular-loading-bar
 *
 * intercepts XHR requests and creates a loading bar.
 * Based on the excellent nprogress work by rstacruz (more info in readme)
 *
 * (c) 2013 Wes Cruver
 * License: MIT
 */


(function() {

'use strict';

// Alias the loading bar for various backwards compatibilities since the project has matured:
angular.module('angular-loading-bar', ['cfp.loadingBarInterceptor']);
angular.module('chieffancypants.loadingBar', ['cfp.loadingBarInterceptor']);


/**
 * loadingBarInterceptor service
 *
 * Registers itself as an Angular interceptor and listens for XHR requests.
 */
angular.module('cfp.loadingBarInterceptor', ['cfp.loadingBar'])
  .config(['$httpProvider', function ($httpProvider) {

    var interceptor = ['$q', '$cacheFactory', '$timeout', '$rootScope', '$log', 'cfpLoadingBar', function ($q, $cacheFactory, $timeout, $rootScope, $log, cfpLoadingBar) {

      /**
       * The total number of requests made
       */
      var reqsTotal = 0;

      /**
       * The number of requests completed (either successfully or not)
       */
      var reqsCompleted = 0;

      /**
       * The amount of time spent fetching before showing the loading bar
       */
      var latencyThreshold = cfpLoadingBar.latencyThreshold;

      /**
       * $timeout handle for latencyThreshold
       */
      var startTimeout;


      /**
       * calls cfpLoadingBar.complete() which removes the
       * loading bar from the DOM.
       */
      function setComplete() {
        $timeout.cancel(startTimeout);
        cfpLoadingBar.complete();
        reqsCompleted = 0;
        reqsTotal = 0;
      }

      /**
       * Determine if the response has already been cached
       * @param  {Object}  config the config option from the request
       * @return {Boolean} retrns true if cached, otherwise false
       */
      function isCached(config) {
        var cache;
        var defaultCache = $cacheFactory.get('$http');
        var defaults = $httpProvider.defaults;

        // Choose the proper cache source. Borrowed from angular: $http service
        if ((config.cache || defaults.cache) && config.cache !== false &&
          (config.method === 'GET' || config.method === 'JSONP')) {
            cache = angular.isObject(config.cache) ? config.cache
              : angular.isObject(defaults.cache) ? defaults.cache
              : defaultCache;
        }

        var cached = cache !== undefined ?
          cache.get(config.url) !== undefined : false;

        if (config.cached !== undefined && cached !== config.cached) {
          return config.cached;
        }
        config.cached = cached;
        return cached;
      }


      return {
        'request': function(config) {
          // Check to make sure this request hasn't already been cached and that
          // the requester didn't explicitly ask us to ignore this request:
          if (!config.ignoreLoadingBar && !isCached(config)) {
            $rootScope.$broadcast('cfpLoadingBar:loading', {url: config.url});
            if (reqsTotal === 0) {
              startTimeout = $timeout(function() {
                cfpLoadingBar.start();
              }, latencyThreshold);
            }
            reqsTotal++;
            cfpLoadingBar.set(reqsCompleted / reqsTotal);
          }
          return config;
        },

        'response': function(response) {
          if (!response || !response.config) {
            $log.error('Broken interceptor detected: Config object not supplied in response:\n https://github.com/chieffancypants/angular-loading-bar/pull/50');
            return response;
          }

          if (!response.config.ignoreLoadingBar && !isCached(response.config)) {
            reqsCompleted++;
            $rootScope.$broadcast('cfpLoadingBar:loaded', {url: response.config.url, result: response});
            if (reqsCompleted >= reqsTotal) {
              setComplete();
            } else {
              cfpLoadingBar.set(reqsCompleted / reqsTotal);
            }
          }
          return response;
        },

        'responseError': function(rejection) {
          if (!rejection || !rejection.config) {
            $log.error('Broken interceptor detected: Config object not supplied in rejection:\n https://github.com/chieffancypants/angular-loading-bar/pull/50');
            return $q.reject(rejection);
          }

          if (!rejection.config.ignoreLoadingBar && !isCached(rejection.config)) {
            reqsCompleted++;
            $rootScope.$broadcast('cfpLoadingBar:loaded', {url: rejection.config.url, result: rejection});
            if (reqsCompleted >= reqsTotal) {
              setComplete();
            } else {
              cfpLoadingBar.set(reqsCompleted / reqsTotal);
            }
          }
          return $q.reject(rejection);
        }
      };
    }];

    $httpProvider.interceptors.push(interceptor);
  }]);


/**
 * Loading Bar
 *
 * This service handles adding and removing the actual element in the DOM.
 * Generally, best practices for DOM manipulation is to take place in a
 * directive, but because the element itself is injected in the DOM only upon
 * XHR requests, and it's likely needed on every view, the best option is to
 * use a service.
 */
angular.module('cfp.loadingBar', [])
  .provider('cfpLoadingBar', function() {

    this.autoIncrement = true;
    this.includeSpinner = true;
    this.includeBar = true;
    this.latencyThreshold = 100;
    this.startSize = 0.02;
    this.parentSelector = 'body';
    this.spinnerTemplate = '<div id="loading-bar-spinner"><div class="spinner-icon"></div></div>';
    this.loadingBarTemplate = '<div id="loading-bar"><div class="bar"><div class="peg"></div></div></div>';

    this.$get = ['$injector', '$document', '$timeout', '$rootScope', function ($injector, $document, $timeout, $rootScope) {
      var $animate;
      var $parentSelector = this.parentSelector,
        loadingBarContainer = angular.element(this.loadingBarTemplate),
        loadingBar = loadingBarContainer.find('div').eq(0),
        spinner = angular.element(this.spinnerTemplate);

      var incTimeout,
        completeTimeout,
        started = false,
        status = 0;

      var autoIncrement = this.autoIncrement;
      var includeSpinner = this.includeSpinner;
      var includeBar = this.includeBar;
      var startSize = this.startSize;

      /**
       * Inserts the loading bar element into the dom, and sets it to 2%
       */
      function _start() {
        if (!$animate) {
          $animate = $injector.get('$animate');
        }

        $timeout.cancel(completeTimeout);

        // do not continually broadcast the started event:
        if (started) {
          return;
        }

        var document = $document[0];
        var parent = document.querySelector ?
          document.querySelector($parentSelector)
          : $document.find($parentSelector)[0]
        ;

        if (! parent) {
          parent = document.getElementsByTagName('body')[0];
        }

        var $parent = angular.element(parent);
        var $after = parent.lastChild && angular.element(parent.lastChild);

        $rootScope.$broadcast('cfpLoadingBar:started');
        started = true;

        if (includeBar) {
          $animate.enter(loadingBarContainer, $parent, $after);
        }

        if (includeSpinner) {
          $animate.enter(spinner, $parent, loadingBarContainer);
        }

        _set(startSize);
      }

      /**
       * Set the loading bar's width to a certain percent.
       *
       * @param n any value between 0 and 1
       */
      function _set(n) {
        if (!started) {
          return;
        }
        var pct = (n * 100) + '%';
        loadingBar.css('width', pct);
        status = n;

        // increment loadingbar to give the illusion that there is always
        // progress but make sure to cancel the previous timeouts so we don't
        // have multiple incs running at the same time.
        if (autoIncrement) {
          $timeout.cancel(incTimeout);
          incTimeout = $timeout(function() {
            _inc();
          }, 250);
        }
      }

      /**
       * Increments the loading bar by a random amount
       * but slows down as it progresses
       */
      function _inc() {
        if (_status() >= 1) {
          return;
        }

        var rnd = 0;

        // TODO: do this mathmatically instead of through conditions

        var stat = _status();
        if (stat >= 0 && stat < 0.25) {
          // Start out between 3 - 6% increments
          rnd = (Math.random() * (5 - 3 + 1) + 3) / 100;
        } else if (stat >= 0.25 && stat < 0.65) {
          // increment between 0 - 3%
          rnd = (Math.random() * 3) / 100;
        } else if (stat >= 0.65 && stat < 0.9) {
          // increment between 0 - 2%
          rnd = (Math.random() * 2) / 100;
        } else if (stat >= 0.9 && stat < 0.99) {
          // finally, increment it .5 %
          rnd = 0.005;
        } else {
          // after 99%, don't increment:
          rnd = 0;
        }

        var pct = _status() + rnd;
        _set(pct);
      }

      function _status() {
        return status;
      }

      function _completeAnimation() {
        status = 0;
        started = false;
      }

      function _complete() {
        if (!$animate) {
          $animate = $injector.get('$animate');
        }

        $rootScope.$broadcast('cfpLoadingBar:completed');
        _set(1);

        $timeout.cancel(completeTimeout);

        // Attempt to aggregate any start/complete calls within 500ms:
        completeTimeout = $timeout(function() {
          var promise = $animate.leave(loadingBarContainer, _completeAnimation);
          if (promise && promise.then) {
            promise.then(_completeAnimation);
          }
          $animate.leave(spinner);
        }, 500);
      }

      return {
        start            : _start,
        set              : _set,
        status           : _status,
        inc              : _inc,
        complete         : _complete,
        autoIncrement    : this.autoIncrement,
        includeSpinner   : this.includeSpinner,
        latencyThreshold : this.latencyThreshold,
        parentSelector   : this.parentSelector,
        startSize        : this.startSize
      };


    }];     //
  });       // wtf javascript. srsly
})();       //
;
angular.module('ui.bootstrap.position', [])

/**
 * A set of utility methods that can be use to retrieve position of DOM elements.
 * It is meant to be used where we need to absolute-position DOM elements in
 * relation to other, existing elements (this is the case for tooltips, popovers,
 * typeahead suggestions etc.).
 */
  .factory('$position', ['$document', '$window', function ($document, $window) {

    function getStyle(el, cssprop) {
      if (el.currentStyle) { //IE
        return el.currentStyle[cssprop];
      } else if ($window.getComputedStyle) {
        return $window.getComputedStyle(el)[cssprop];
      }
      // finally try and get inline style
      return el.style[cssprop];
    }

    /**
     * Checks if a given element is statically positioned
     * @param element - raw DOM element
     */
    function isStaticPositioned(element) {
      return (getStyle(element, 'position') || 'static' ) === 'static';
    }

    /**
     * returns the closest, non-statically positioned parentOffset of a given element
     * @param element
     */
    var parentOffsetEl = function (element) {
      var docDomEl = $document[0];
      var offsetParent = element.offsetParent || docDomEl;
      while (offsetParent && offsetParent !== docDomEl && isStaticPositioned(offsetParent) ) {
        offsetParent = offsetParent.offsetParent;
      }
      return offsetParent || docDomEl;
    };

    return {
      /**
       * Provides read-only equivalent of jQuery's position function:
       * http://api.jquery.com/position/
       */
      position: function (element) {
        var elBCR = this.offset(element);
        var offsetParentBCR = { top: 0, left: 0 };
        var offsetParentEl = parentOffsetEl(element[0]);
        if (offsetParentEl != $document[0]) {
          offsetParentBCR = this.offset(angular.element(offsetParentEl));
          offsetParentBCR.top += offsetParentEl.clientTop - offsetParentEl.scrollTop;
          offsetParentBCR.left += offsetParentEl.clientLeft - offsetParentEl.scrollLeft;
        }

        var boundingClientRect = element[0].getBoundingClientRect();
        return {
          width: boundingClientRect.width || element.prop('offsetWidth'),
          height: boundingClientRect.height || element.prop('offsetHeight'),
          top: elBCR.top - offsetParentBCR.top,
          left: elBCR.left - offsetParentBCR.left
        };
      },

      /**
       * Provides read-only equivalent of jQuery's offset function:
       * http://api.jquery.com/offset/
       */
      offset: function (element) {
        var boundingClientRect = element[0].getBoundingClientRect();
        return {
          width: boundingClientRect.width || element.prop('offsetWidth'),
          height: boundingClientRect.height || element.prop('offsetHeight'),
          top: boundingClientRect.top + ($window.pageYOffset || $document[0].documentElement.scrollTop),
          left: boundingClientRect.left + ($window.pageXOffset || $document[0].documentElement.scrollLeft)
        };
      },

      /**
       * Provides coordinates for the targetEl in relation to hostEl
       */
      positionElements: function (hostEl, targetEl, positionStr, appendToBody) {

        var positionStrParts = positionStr.split('-');
        var pos0 = positionStrParts[0], pos1 = positionStrParts[1] || 'center';

        var hostElPos,
          targetElWidth,
          targetElHeight,
          targetElPos;

        hostElPos = appendToBody ? this.offset(hostEl) : this.position(hostEl);

        targetElWidth = targetEl.prop('offsetWidth');
        targetElHeight = targetEl.prop('offsetHeight');

        var shiftWidth = {
          center: function () {
            return hostElPos.left + hostElPos.width / 2 - targetElWidth / 2;
          },
          left: function () {
            return hostElPos.left;
          },
          right: function () {
            return hostElPos.left + hostElPos.width;
          }
        };

        var shiftHeight = {
          center: function () {
            return hostElPos.top + hostElPos.height / 2 - targetElHeight / 2;
          },
          top: function () {
            return hostElPos.top;
          },
          bottom: function () {
            return hostElPos.top + hostElPos.height;
          }
        };

        switch (pos0) {
          case 'right':
            targetElPos = {
              top: shiftHeight[pos1](),
              left: shiftWidth[pos0]()
            };
            break;
          case 'left':
            targetElPos = {
              top: shiftHeight[pos1](),
              left: hostElPos.left - targetElWidth
            };
            break;
          case 'bottom':
            targetElPos = {
              top: shiftHeight[pos0](),
              left: shiftWidth[pos1]()
            };
            break;
          default:
            targetElPos = {
              top: hostElPos.top - targetElHeight,
              left: shiftWidth[pos1]()
            };
            break;
        }

        return targetElPos;
      }
    };
  }]);
;
(function () {
  'use strict';

  angular.extend(window.config, {
    appId: 'kb',
    appPath: window.config.kbRoute,
    appName: 'Reference Docs'
  });

  var appConfig = window.config;
  var appConfigModule = angular.module('Q.config.app-config', []).run(['$rootScope', function ($rootScope) {
    $rootScope.appConfig = appConfig;
  }]);

  var angularCoreConfigModule = angular.module('Q.config.angular-log', []).config(['$logProvider', '$compileProvider', '$qProvider', function ($logProvider, $compileProvider, $qProvider) {
    // Only log debug events on dev mode
    $logProvider.debugEnabled(appConfig.devMode);

    // Only render debug data on dev mode, or when debug=true in the URL
    $compileProvider.debugInfoEnabled(appConfig.devMode || /debug=true/.test(window.location.search));

    // Prevent $q from throwing errors on unhandled rejections on newer versions
    if ($qProvider.errorOnUnhandledRejections) {
      // TODO: is it worth cleaning up the codebase for this?
      $qProvider.errorOnUnhandledRejections(false);
    }
  }]).run(['$timeout', function ($timeout) {
    // Disables pre-load error handling after the application loads
    $timeout(function () {
      // At this point, we should be able to rely on Angular for rendering errors
      appConfig.isLoaded = true;
    }, 1, false);
  }]);

  var loadingBarModule = 'cfp.loadingBarInterceptor';

  var loadingBarConfigModule = angular.module('Q.config.loading-bar', [loadingBarModule])

  /**
   * Overrides the default loading bar interceptor during a route change for
   * a smoother loading animation
   */
  .factory('loadingBarRouteHandlerInterceptor', ['$rootScope', '$timeout', 'cfpLoadingBar', function loadingBarRouteHandlerInterceptor($rootScope, $timeout, cfpLoadingBar) {
    // Used to track when we are overriding the default loading bar, so we can prevent it
    var isLoadingRoute = false;

    // always delay the loading bar a bit, so we don't show it on quick route changes
    var starterTimeout = null;

    // Automatically ignore any state without resolves, or if a state has explicitly requested that
    // the default behavior is preserved.
    function ignoreState(state) {
      return !state || !state.resolve || state.data && state.data.defaultLoadingBar;
    }

    $rootScope.$on('$stateChangeStart', function (event, toState) {
      if (ignoreState(toState)) return;

      isLoadingRoute = true;
      starterTimeout = $timeout(function () {
        cfpLoadingBar.start();
        starterTimeout = null;
      }, 100);
    });

    function complete(event, toState) {
      if (ignoreState(toState)) return;

      isLoadingRoute = false;
      if (starterTimeout) {
        $timeout.cancel(starterTimeout);
        starterTimeout = null;
      }
      cfpLoadingBar.complete();
    }

    $rootScope.$on('$stateChangeSuccess', complete);
    $rootScope.$on('$stateChangeError', complete);

    return {
      request: function request(config) {
        if (isLoadingRoute) {
          config.ignoreLoadingBar = true;
        }
        return config;
      }
    };
  }]).config(['cfpLoadingBarProvider', '$httpProvider', function (cfpLoadingBarProvider, $httpProvider) {
    // make sure our route handler interceptor is first
    $httpProvider.interceptors.unshift('loadingBarRouteHandlerInterceptor');

    cfpLoadingBarProvider.includeSpinner = false;
  }]);

  var configModule = angular.module('Q.config', [appConfigModule, angularCoreConfigModule, loadingBarConfigModule]);

  var IGNORED_ERRORS = /InvalidAccessError|SecurityError/;

  // Use to decorate a function to prevent errors.
  var tryFunctionHelperModule = angular.module('Q.helpers.try-function', []).factory('tryFunction', ['$log', function ($log) {
    return function tryFunction(fn) {
      return function () {
        try {
          return fn.apply(undefined, arguments);
        } catch (ex) {
          if (IGNORED_ERRORS.test(ex)) {
            // Log security errors as warnings instead of debug so they're visible in production
            $log.warn('[SmartIDE] Security error (expected):', ex);
          } else {
            // $log.error automatically sends to Sentry
            $log.error(ex);
          }
        }
      };
    };
  }]);

  /* eslint-disable angular/no-private-call,angular/timeout-service */

  var timerHelperModule = angular.module('Q.helpers.timer-helper', []).factory('timerHelper', ['$rootScope', '$window', '$q', '$exceptionHandler', '$$q', function ($rootScope, $window, $q, $exceptionHandler, $$q) {
    var deferreds = {};

    /**
     * Drop-in replacement for Angular's $timeout, but designed to run outside the framework a bit,
     * so it doesn't cause Angular to stay in a "non-stable" state for testing purposes.
     *
     * @param fn
     * @param delay
     * @param invokeApply
     * @param args
     */
    function longTimeout(fn, delay) {
      for (var _len = arguments.length, args = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
        args[_key - 3] = arguments[_key];
      }

      var invokeApply = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      if (!angular.isFunction(fn)) {
        invokeApply = delay;
        delay = fn;
        fn = angular.noop;
      }

      var deferred = (invokeApply ? $q : $$q).defer();
      var promise = deferred.promise;
      var timeoutId = void 0;

      timeoutId = $window.setTimeout(function () {
        try {
          deferred.resolve(fn.apply(null, args));
        } catch (e) {
          deferred.reject(e);
          $exceptionHandler(e);
        } finally {
          delete deferreds[promise.$$timeoutId];
        }

        if (invokeApply) $rootScope.$apply();
      }, delay);

      promise.$$timeoutId = timeoutId;
      deferreds[timeoutId] = deferred;

      return promise;
    }

    /**
     * Cancels a previously configured longTimeout
     * @param promise Promise to cancel that was returned from longTimeout()
     * @returns {boolean}
     */
    longTimeout.cancel = function (promise) {
      if (promise && promise.$$timeoutId in deferreds) {
        // Timeout cancels should not report an unhandled promise.
        deferreds[promise.$$timeoutId].promise.catch(angular.noop);
        deferreds[promise.$$timeoutId].reject('canceled');
        delete deferreds[promise.$$timeoutId];
        return $window.clearTimeout(promise.$$timeoutId);
      }
      return false;
    };

    /**
     * Creates a recurring timer that is more guaranteed to run every [delay] milliseconds than $interval
     * @param fn Function to call on every tick
     * @param delay How often to run the timer
     * @param invokeApply Whether or not to invoke apply after each event
     * @param args Extra args passed to the function
     * @returns {{ stop, start, running }} An object that can be used to cancel the timer.
     */
    function runEvery(fn, delay) {
      for (var _len2 = arguments.length, args = Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
        args[_key2 - 3] = arguments[_key2];
      }

      var invokeApply = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      var nextEventTime = Date.now() + delay;

      var ret = {
        stop: function stop() {
          runEvery.cancel(this);
        },
        start: function start() {
          if (!this.running) {
            queueNextEvent();
          }
        }
      };

      function event() {
        // queue next event first, so it can be stopped/canceled by the timed event
        queueNextEvent();
        fn.apply(undefined, args);
      }

      function queueNextEvent() {
        if (ret.$$runEveryPromise) {
          runEvery.cancel(ret);
        }
        var now = Date.now();
        // determine the next trigger delay--skipping over any frames we've already passed if necessary
        while (nextEventTime < now) {
          nextEventTime += delay;
        }var eventDelay = nextEventTime - now;
        nextEventTime += delay;

        ret.$$runEveryPromise = longTimeout(event, eventDelay, invokeApply);
        event.running = true;
      }

      event();

      return ret;
    }

    /**
     * Cancels a runEvery event
     * @param event
     */
    runEvery.cancel = function (event) {
      if (event && event.$$runEveryPromise) {
        longTimeout.cancel(event.$$runEveryPromise);
        event.$$runEveryPromise = false;
        event.running = false;
      }
    };

    return {
      longTimeout: longTimeout,
      runEvery: runEvery
    };
  }]);

  var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  };

  var classCallCheck = function (instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  };

  var createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  var slicedToArray = function () {
    function sliceIterator(arr, i) {
      var _arr = [];
      var _n = true;
      var _d = false;
      var _e = undefined;

      try {
        for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
          _arr.push(_s.value);

          if (i && _arr.length === i) break;
        }
      } catch (err) {
        _d = true;
        _e = err;
      } finally {
        try {
          if (!_n && _i["return"]) _i["return"]();
        } finally {
          if (_d) throw _e;
        }
      }

      return _arr;
    }

    return function (arr, i) {
      if (Array.isArray(arr)) {
        return arr;
      } else if (Symbol.iterator in Object(arr)) {
        return sliceIterator(arr, i);
      } else {
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
      }
    };
  }();

  function isPrimitive(v) {
    return !isFunction(v) && !isObject(v);
  }

  function isString(s) {
    return typeof s === 'string';
  }

  function isObject(value) {
    return value !== null && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object';
  }

  function isFunction(v) {
    return typeof v === 'function';
  }

  var isArray = Array.isArray;

  /**
   * Stops an event from happening
   * @param $event
   */
  function stopEvent($event) {
    if (isFunction($event)) {
      return function (ev) {
        stopEvent(ev);

        for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }

        return $event.apply(undefined, args);
      };
    }
    if ($event) {
      if ($event.preventDefault) $event.preventDefault();
      $event.returnValue = false;
      stopBubbling($event);
    }
  }

  /**
   * Stops an event from propagating
   * @param $event
   */
  function stopBubbling($event) {
    if ($event) {
      if ($event.stopPropagation) $event.stopPropagation();
      $event.cancelBubble = true;
    }
  }

  var CustomEvent = function () {
    if (isFunction(window.CustomEvent)) return window.CustomEvent; // For modern browsers

    function CustomEvent(event) {
      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref$bubbles = _ref.bubbles,
          bubbles = _ref$bubbles === undefined ? false : _ref$bubbles,
          _ref$cancelable = _ref.cancelable,
          cancelable = _ref$cancelable === undefined ? false : _ref$cancelable,
          detail = _ref.detail;

      var evt = document.createEvent('CustomEvent');
      evt.initCustomEvent(event, bubbles, cancelable, detail);
      return evt;
    }

    CustomEvent.prototype = window.Event.prototype;

    return window.CustomEvent = CustomEvent;
  }();

  // Intercom is no longer used. This module remains as a compatibility layer for
  // existing support entrypoints (eg. `intercom-button`) and now routes users to
  // email-based support.
  var intercomServiceModule = angular.module('Q.services.intercom-service', [timerHelperModule]).factory('intercomService', ['$window', 'timerHelper', '$rootScope', '$log', function ($window, timerHelper, $rootScope, $log) {
    var SUPPORT_EMAIL = 'support@qualified.io';
    var DEFAULT_SUBJECT = 'Qualified Support';

    var updateTimer = null;

    function buildMailtoHref() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          subject = _ref.subject,
          body = _ref.body;

      var params = [];
      if (subject) params.push('subject=' + encodeURIComponent(subject));
      if (body) params.push('body=' + encodeURIComponent(body));
      var query = params.length ? '?' + params.join('&') : '';
      return 'mailto:' + SUPPORT_EMAIL + query;
    }

    function openMailto() {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          subject = _ref2.subject,
          body = _ref2.body;

      try {
        $window.location.href = buildMailtoHref({ subject: subject, body: body });
      } catch (e) {
        // Don't break the UI if navigation fails in some embedded contexts.
        $log.debug(e);
      }
    }

    var service = {
      // Compatibility no-ops (Intercom removed)
      setUser: function setUser() {
        $rootScope.$broadcast('intercom.isActive', false);
        return service;
      },
      unsetUser: function unsetUser() {
        $rootScope.$broadcast('intercom.isActive', false);
        return service;
      },
      trackPage: function trackPage() {
        return service;
      },
      trackEvent: function trackEvent() {
        return service;
      },
      delayUpdate: function delayUpdate(delay, data) {
        timerHelper.longTimeout.cancel(updateTimer);

        updateTimer = timerHelper.longTimeout(function () {
          service.update(data);
        }, delay || 2000, false);
      },
      update: function update() {
        return service;
      },
      show: function show(msg) {
        var body = '';
        if (msg && msg !== true) body = String(msg);
        openMailto({ subject: DEFAULT_SUBJECT, body: body });
        return service;
      },
      hide: function hide() {
        return service;
      },
      toggle: function toggle() {
        return service.show();
      },
      isActive: function isActive() {
        return false;
      },
      showWidget: function showWidget() {
        // Always allow support entrypoints to render, even though Intercom is gone.
        return true;
      },
      supportMailtoHref: function supportMailtoHref() {
        var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            subject = _ref3.subject,
            body = _ref3.body;

        return buildMailtoHref({
          subject: subject || DEFAULT_SUBJECT,
          body: body
        });
      }
    };

    return service;
  }]).run(['$rootScope', 'intercomService', function ($rootScope, intercomService) {
    $rootScope.$on('$stateChangeSuccess', function () {
      return intercomService.delayUpdate(1000);
    });
  }]).directive('intercomHide', function () {
    return {
      restrict: 'A',
      link: function link(scope, elem) {
        // Intercom is removed, but keep the element visible for support entrypoints.
        elem.toggleClass('ng-hide', false);
      }
    };
  }).directive('intercomButton', ['intercomService', function (intercomService) {
    return {
      restrict: 'A',
      link: function link(scope, elem, attr) {
        elem.addClass('intercom-button');
        elem.attr('tabindex', 0);
        var msgAttr = attr.intercomButtonMessage;
        var msg = msgAttr === 'true' || msgAttr === '' ? '' : msgAttr;

        var existingHref = elem.attr('href');
        var shouldSetHref = !existingHref || existingHref === '' || existingHref === '#';
        if (shouldSetHref) {
          elem.attr('href', intercomService.supportMailtoHref({ body: msg }));
          elem.attr('target', '_blank');
          elem.attr('rel', 'noopener');
        }

        // Ensure mailto works even if something prevents default navigation.
        elem.on('click', function (event) {
          if (shouldSetHref) {
            stopEvent(event);
            intercomService.show(msg);
          }
        });
        if (!attr.title && !attr.tooltip) {
          elem.attr('title', 'Email Qualified Support');
        }
      }
    };
  }]).directive('modalContent', ['$compile', function ($compile) {
    return {
      restrict: 'C',
      link: function link(scope, elem) {
        var nodeLink = $compile('<a intercom-button track-click="Support Email Clicked" track-data="{ui: {region: \'dialog\'}}"></a>')(scope);
        elem.append(nodeLink);
      }
    };
  }]);

  var toString = String;

  var pastTenseExceptions = {
    are: 'were',
    eat: 'ate',
    go: 'went',
    have: 'had',
    inherit: 'inherited',
    is: 'was',
    run: 'ran',
    sit: 'sat',
    visit: 'visited'
  };

  // taken from https://gist.github.com/letsgetrandy/1e05a68ea74ba6736eb5
  function pastTense(verb) {
    // if already past tensed
    if (/ed$/.test(verb)) {
      return verb;
    }
    if (pastTenseExceptions[verb]) {
      return pastTenseExceptions[verb];
    }
    if (/e$/i.test(verb)) {
      return verb + 'd';
    }
    if (/[aeiou]c$/i.test(verb)) {
      return verb + 'ked';
    }
    if (/el$/i.test(verb)) {
      return verb + 'ed';
    }
    if (/[aeio][aeiou][dlmnprst]$/.test(verb)) {
      return verb + 'ed';
    }
    if (/[aeiou][b-df-hj-np-tv-z]+[aeiou][bdglmnprst]$/i.test(verb)) {
      return verb + 'ed';
    }
    if (/[aeiou][bdglmnprst]$/i.test(verb)) {
      return verb.replace(/(.+[aeiou])([bdglmnprst])/, '$1$2$2ed');
    }
    return verb + 'ed';
  }

  function upperCaseWords(str) {
    return toString(str).replace(/(?:^|\s)\S/g, function (a) {
      return a.toUpperCase();
    });
  }

  // TAKEN FROM https://developer.mozilla.org/en-US/docs/Web/API/document/cookie
  // 1.3 version of angular-cookies does not support setting path values which we require, so using the MDN version
  // TODO: upgrade once angular 1.4 is upgraded
  function escapeCookieKey(sKey) {
    return encodeURIComponent(sKey).replace(/[\-\.\+\*]/g, '\\$&');
  }

  function getCookie(sKey) {
    if (!sKey) {
      return null;
    }
    var searchPattern = new RegExp('(?:(?:^|.*;)\\s*' + escapeCookieKey(sKey) + '\\s*\\=\\s*([^;]*).*$)|^.*$');
    return decodeURIComponent(document.cookie.replace(searchPattern, '$1')) || null;
  }

  function setCookie(sKey, sValue, vEnd, sPath, sDomain, bSecure) {
    if (!sKey || /^(?:expires|max\-age|path|domain|secure)$/i.test(sKey)) {
      return false;
    }
    var sExpires = '';
    if (vEnd) {
      switch (vEnd.constructor) {
        case Number:
          sExpires = vEnd === Infinity ? '; expires=Fri, 31 Dec 9999 23:59:59 GMT' : '; max-age=' + vEnd;
          break;
        case String:
          sExpires = '; expires=' + vEnd;
          break;
        case Date:
          sExpires = '; expires=' + vEnd.toUTCString();
          break;
      }
    }
    document.cookie = encodeURIComponent(sKey) + '=' + encodeURIComponent(sValue) + sExpires + (sDomain ? '; domain=' + sDomain : '') + (sPath ? '; path=' + sPath : '') + (bSecure ? '; secure' : '');
    return true;
  }

  function hasCookie(sKey) {
    if (!sKey) {
      return false;
    }
    return new RegExp('(?:^|;\\s*)' + escapeCookieKey(sKey) + '\\s*\\=').test(document.cookie);
  }

  var UTM_KEY = '$qualified$utm';

  // captures UTM properties on page load and preserves them across the site
  var utmProps = {};

  try {
    var storage = JSON.parse(window.localStorage[UTM_KEY] || '{}');
    Object.assign(utmProps, storage);
  } catch (err) {}
  /* ignore errors */


  // even if we couldn't parse the stored props, lets try to get new ones
  try {
    if (window.URL) {
      var utmTester = /^utm_/;
      var params = new URL(document.location).searchParams;
      if (params) {
        params.forEach(function (val, key) {
          var k = key.toLowerCase();
          if (utmTester.test(k) && val) {
            if (val === 'null') {
              delete utmProps[k];
            } else {
              utmProps[k] = val;
            }
          }
        });
        utmProps.referrer = document.referrer;
        utmProps.initialReferrer = utmProps.initialReferrer || document.referrer;
        window.localStorage[UTM_KEY] = JSON.stringify(utmProps);
      }
    }
  } catch (err) {
    /* ignore errors */
  }

  var ACCOUNT_SERVICE_KEY = 'accountService';

  var accountService = void 0;

  function getAccountService($injector) {
    if (!accountService) {
      accountService = $injector.has(ACCOUNT_SERVICE_KEY) && $injector.get(ACCOUNT_SERVICE_KEY);
    }
    return accountService;
  }

  function getImpersonateId() {
    return getCookie('impersonator_id');
  }

  var trackerServiceModule = angular.module('Q.services.tracker-service', [tryFunctionHelperModule, intercomServiceModule]).factory('tracker', ['$window', 'intercomService', '$injector', 'tryFunction', '$log', function ($window, intercomService, $injector, tryFunction, $log) {
    // assign the appname as a custom session variable
    if ($window.ga) {
      $window.ga('set', 'dimension1', appConfig.appName);
    }

    var service = {
      shouldTrack: shouldTrack,

      setUser: tryFunction(function (user) {
        if (shouldTrack()) {
          if ($window.analytics) {
            if (user.user) {
              user = user.user;
            }

            service.user = user;

            var userData = {};

            if (user.team) {
              $window.analytics.group(user.teamId, user.team);
              // some analytics services don't respond to analytics.group, so track the key team properties as fields
              userData = {
                customer: {
                  id: user.team.customerId,
                  name: user.team.customer && user.team.customer.name,
                  state: user.team.customer && user.team.customer.state,
                  trialEndedAt: user.team.customer && user.team.customer.trialEndedAt
                },
                team: {
                  name: user.team.name,
                  primary: user.team.primaryTeam,
                  // legacy trait
                  subscriptionState: user.team.customer && user.team.customer.state,
                  state: user.team.state
                }
              };
            }

            $window.analytics.identify(user.id, angular.extend({}, user, userData), setContext());
          }

          // Implement fullstory set user here (Datadog rum replacement)

          intercomService.setUser(angular.extend({}, user, utmProps));
        }
      }),
      unsetUser: tryFunction(function () {
        service.user = null;

        if ($window.analytics) {
          $window.analytics.reset();
        }
        if ($window.mixpanel && $window.mixpanel.cookie) {
          $window.mixpanel.cookie.clear();
        }
        // Implement fullstory clear user here (Datadog rum replacement)

        intercomService.unsetUser();
      }),
      trackPage: tryFunction(function (name, props, options) {
        props = props || {};
        props.app = appConfig.appName;
        props.env = appConfig.env;

        if ($window.analytics && shouldTrack()) {
          $window.analytics.page(name, props, setContext(options));
        }
        intercomService.trackPage();
      }),
      trackEvent: tryFunction(function (name, properties) {
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

        if (appConfig.devMode) {
          $log.debug('trackEvent:', name, properties, options);
        }

        if (shouldTrack()) {
          var $state = $injector.has('$state') && $injector.get('$state');
          // always include these basic properties
          var props = angular.extend({
            app: appConfig.appName,
            env: appConfig.env,
            ui: {}
          }, properties);
          props.ui.$state = $state && $state.current && $state.current.name;

          if ($window.analytics) {
            $window.analytics.track(name, props, setContext(options));
          } else if ($window.ga) {
            var _props = properties || {};
            $window.ga('send', 'event', {
              eventCategory: appConfig.appName,
              eventAction: name,
              // try to guess which key--if any--might work as the event label
              eventLabel: _props[['name', 'title', 'state', 'label', 'message', 'id'].find(function (k) {
                return _props[k];
              })],
              eventValue: !isNaN(_props.value) ? _props.value : null
            });
          }
          // Implement fullstory add action here (Datadog rum replacement)

          if (options.intercom !== false) {
            intercomService.trackEvent(name, properties);
          }
        }
      }),
      trackError: tryFunction(function (name, properties) {
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

        $log.error(name, properties);
        service.trackEvent('Error: ' + name, properties, options);
      }),
      // extended version of trackEvent, which takes a model instance. If the properties are provided as a
      // function, the result of that function will be be returned. If no properties are provided, then
      // the properties will be derived from the model instance.
      trackModelEvent: tryFunction(function (instance, name, properties) {
        if (!instance) return;
        // if track properties were specifically configured then use those instead
        if (properties) {
          if (angular.isFunction(properties)) {
            properties = properties(instance);
          }
          // if the instance support a trackProperties method, then use that as the default. Otherwise
          // just use key fields from the instance itself.
        } else {
          var defaults = {
            id: instance.id,
            $type: instance.$type,
            name: instance.name,
            title: instance.title,
            candidate: instance.candidate ? instance.candidate.email : undefined,
            team: instance.team ? instance.team.name : undefined
          };
          properties = instance.trackProperties ? instance.trackProperties(defaults) : defaults;
        }
        service.trackEvent(name, properties, { intercom: false });
      })
    };

    function shouldTrack() {
      var accountService = getAccountService($injector);
      var account = accountService && accountService.get();

      // If there is a current user
      if (account.user) {
        return account.verified && // must be verified in the service
        account.user.role !== 'staff' && // must not be a staff member
        !account.user.demoAccount && ( // must not be a demo account
        account.user.$type !== 'Candidate' || !account.user.isActive || account.user.isActive()) && // must not be an inactive candidate
        !getImpersonateId(); // must not be impersonating this user
      }
      // otherwise we do not currently track anonymous users
      return false;
    }

    function setContext(options) {
      options = options || {};
      // by default segment only passes along utm values if they are in the current url.
      // We are going to pull them from the cookie so that everything gets tracked back to the source referrer.
      options.context = {
        campaign: {
          name: utmProps.utm_campaign,
          source: utmProps.utm_source,
          medium: utmProps.utm_medium,
          term: utmProps.utm_term,
          content: utmProps.utm_content
        }
      };

      return options;
    }

    return service;
  }]).run(['tracker', '$rootScope', '$injector', 'tryFunction', function (tracker, $rootScope, $injector, tryFunction) {
    var rebroadcastEvents = ['app.accountSet', 'app.login', 'app.logout'];

    rebroadcastEvents.forEach(function (event) {
      $rootScope.$on(event, function (e, args) {
        if (tracker.shouldTrack()) {
          $rootScope.$broadcast('tracker.' + event, args);
        }
      });
    });

    $rootScope.$on('model.actionEndpoint.success', tryFunction(function (e, args) {
      var track = args.options.track;
      if (track) {
        if (angular.isString(track)) {
          track = { event: track };
        }

        if (track === true) {
          track = { event: true };
        } else if (!track.event) {
          track.event = true;
        }

        if (track.event === true) {
          var verb = upperCaseWords(pastTense(args.name));
          track.event = args.model.name + ' ' + verb;
        }

        tracker.trackModelEvent(args.instance, track.event, track.properties);
      }
    }));

    // handles model that are configured to automatically track their CUD events
    $rootScope.$on('model.changed', tryFunction(function (e, args) {
      var track = args.config.meta && args.config.meta.track && args.config.meta.track[args.action];
      if (track) {
        var event = args.action + 'd';
        if (event === 'destroyd') event = 'destroyed';
        event = upperCaseWords(pastTense(event));
        tracker.trackModelEvent(args.instance, args.resourceName + ' ' + event, track === true ? null : track);
      }
    }));

    // collect the previous state on the ui.router $stateChangeStart
    // because the nestedPageTitleHelper pulls the current title
    var previousState = void 0;
    var stateDelimiter = ':';

    $rootScope.$on('tracker.app.accountSet', function (e, account) {
      return tracker.setUser(account);
    });
    $rootScope.$on('tracker.app.logout', function () {
      return tracker.unsetUser();
    });

    $rootScope.$on('$stateChangeStart', tryFunction(function (event, toState, toParams, fromState) {
      // default to tracking state changes unless the
      // route explicitly sets track to false
      if (fromState.track !== false) {
        var fromPageTitle = fromState && fromState.data && fromState.data.pageTitle;
        if (fromPageTitle && !angular.isString(fromPageTitle)) {
          previousState = $injector.invoke(fromPageTitle);
          if (angular.isArray(previousState)) {
            previousState = previousState.join(stateDelimiter);
          }
        } else {
          previousState = '';
        }
      } else {
        previousState = '';
      }
    }));

    $rootScope.$on('$stateChangeSuccess', tryFunction(function (event, toState, toParams, fromState) {
      // these events are noisy as hell so lets not track them in the development environment and save
      // ourselves some money
      // default to tracking state changes unless the
      // route explicitly sets track to false
      if (toState.track !== false && toState.name !== 'error') {
        var toPageTitle = toState.data && toState.data.pageTitle;
        if (toPageTitle && !angular.isString(toPageTitle)) {
          toPageTitle = $injector.invoke(toPageTitle);
          if (angular.isArray(toPageTitle)) {
            toPageTitle = toPageTitle.join(stateDelimiter);
          }
        }

        var props = {
          title: toPageTitle,
          fromStateName: previousState || fromState.name || '',
          toParams: toParams
        };

        // srefProps are set by the ui-sref directive, which utilize the triggering
        // element's track-data attribute.
        angular.merge(props, tracker.srefProps);
        tracker.srefProps = null;

        // turn mixpanel off in dev mode
        var options = {
          mixpanel: appConfig.env !== 'dev'
        };

        var pageName = toState.data && toState.data.label;
        if (!pageName && toPageTitle) {
          pageName = toPageTitle.split(':')[0];
        }

        tracker.trackPage(pageName || toState.name, props, options);
      }
    }));
  }]);

  /**
   * Returns an object with all cyclical references replaced with `«cyclical value»`
   * @param {*} data - Any value
   * @param {Set} foundObjects - A set of already found objects when recursing
   * @returns {*} A copy of the data without any cycles
   */
  function toNonCyclicalObject(data) {
    var foundObjects = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Set();

    var result = void 0;
    if (foundObjects.has(data)) {
      result = '«cyclical value»';
    } else if (isArray(data)) {
      foundObjects.add(data);
      result = data.map(function (v) {
        return toNonCyclicalObject(v, foundObjects);
      });
      foundObjects.delete(data);
    } else if (isObject(data)) {
      foundObjects.add(data);
      var newObj = {};
      Object.keys(data).forEach(function (k) {
        newObj[k] = toNonCyclicalObject(data[k], foundObjects);
      });
      result = newObj;
      foundObjects.delete(data);
    } else {
      result = data;
    }
    return result;
  }

  /**
   * Returns a copy of the data safe for Sentry logging
   * @param {*} data - Any data we want to send to Sentry
   * @param {number} maxDepth - The maximum depth before we render the data as a JSON string (so it isn't lost)
   * @returns {*} A copy of the data safe to log to Sentry
   */
  function toSentrySafeObject(data) {
    var maxDepth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;

    var newObj = {};
    Object.keys(data).forEach(function (k) {
      var v = data[k];
      if (isPrimitive(v)) {
        newObj[k] = v;
      } else if (isArray(v)) {
        if (maxDepth > 0) {
          newObj[k] = v.map(function (v) {
            return toSentrySafeObject(v, maxDepth - 1);
          });
        } else {
          newObj[k] = JSON.stringify(toNonCyclicalObject(v));
        }
      } else if (isObject(v)) {
        if (maxDepth > 0) {
          newObj[k] = toSentrySafeObject(v, maxDepth - 1);
        } else {
          newObj[k] = JSON.stringify(toNonCyclicalObject(v));
        }
      }
    });
    return newObj;
  }

  var oldOnerror = window.onerror;
  var booted = false;
  var doc = window.document;
  window.onerror = prebootError;
  // used because we have to re-throw errors to see them with source maps
  var lastException = null;

  function prebootError(msg /*, url, line, col, error*/) {
    if (oldOnerror) {
      oldOnerror.apply(this, arguments);
    }
    if (!booted && doc) {
      var appName = '';
      if (window.config && window.config.appName) {
        appName = encodeURIComponent(window.config.appName + ' ');
      }
      // wipe out the body content
      doc.body.innerHTML = '<div class="loading-exception">\n\t<h2>Error: Unable to start the application!</h2>\n\t<p>We were unable to get the application started! You can try reloading the page, or <a href="mailto:team@qualified.io?subject=' + appName + 'Application%20Startup%20Issues" target="_blank">contact the team at Qualified.</a></p>\n\t<p>The error that occurred is:</p>\n\t<pre><code>' + msg + '</code></pre>\n</div>';
    }
  }

  function isPlainObject(obj) {
    return angular.isObject(obj) && Object.getPrototypeOf(obj) === Object.prototype;
  }

  function sentryOpts(args) {
    var opts = {};
    if (args.length) {
      if (angular.isString(args[0])) {
        opts.extra = { extraMessage: args.shift() };
      } else if (angular.isNumber(args[0].status) || isPlainObject(args[0])) {
        // capture additional data if this is an $http request or it's a plain object
        opts.extra = toSentrySafeObject(args.shift());
      }
    }
    return opts;
  }

  function sendToSentry($log) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    try {
      if (window.Sentry && (!window.config || !window.config.devMode)) {
        args = args.filter(angular.identity);
        var sent = false;
        // handle simple string arguments
        if (args.length && angular.isString(args[0])) {
          window.Sentry.captureMessage(args.shift(), sentryOpts(args));
          sent = true;
        }
        // handle Error arguments (we might capture 2 events)
        if (args.length && args[0] instanceof Error) {
          window.Sentry.captureException(args.shift(), sentryOpts(args));
          sent = true;
        }
        // handle anything else
        if (!sent) {
          window.Sentry.captureMessage('Non-Error Logged', sentryOpts(args));
        }
      }
    } catch (e) {
      $log.warn('Error logging failure:');
      $log.warn(e);
    }
  }

  var exceptionHandlerServiceModule = angular.module('Q.services.exception-handler', []).run(['$log', '$rootScope', '$injector', '$q', function ($log, $rootScope, $injector, $q) {
    booted = true;
    if (window.onerror === prebootError) {
      window.onerror = oldOnerror;
    } // otherwise, someone else overwrote the onerror, so we just leave it

    // wrap the built-in $log.error function so it sends it to Sentry (after booting)
    var oldError = $log.error;
    $log.error = function () {
      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      oldError.apply($log, args);
      sendToSentry.apply(undefined, [$log].concat(args));
    };

    $log.reject = function () {
      $log.error.apply($log, arguments);
      return $q.reject(arguments.length <= 0 ? undefined : arguments[0]);
    };

    if (window.Sentry) {
      window.Sentry.setTags({
        appName: appConfig.appName,
        env: appConfig.env
      });
      $rootScope.$on('app.accountSet', function ($event, account) {
        if (account && account.user) {
          var user = account.user;
          window.Sentry.setUser({
            id: user.id,
            email: user.email
          });
          var impersonateId = getImpersonateId();
          if (impersonateId) {
            // track that this is an impersonated session
            window.Sentry.setTags({ impersonateId: impersonateId });
          }
        }
      });
      $rootScope.$on('app.logout', function () {
        return window.Sentry.setUser();
      });
    }
  }]).factory('$exceptionHandler', ['$log', '$injector', function ($log, $injector) {
    return function log(exception, cause) {
      if (lastException === exception) return;

      if (cause) {
        try {
          exception.message += ' (caused by "' + cause + '")';
        } catch (e) {
          $log.error('Cause: ', cause);
          // we cannot modify the message without error sometimes
        }
      }
      $log.error(exception);

      if (!booted) {
        // send any uncaught errors to Sentry directly before booting
        sendToSentry($log, exception);
      }

      if (appConfig.devMode && $injector.has('$state')) {
        try {
          var $state = $injector.get('$state');
          $state.go('error', { error: exception, didLog: true });
        } catch (e) {}
      }

      lastException = exception;
      if (exception.stack) {
        // re-throw so we get stack traces with source maps
        // eslint-disable-next-line angular/timeout-service
        setTimeout(function () {
          throw exception;
        });
      }
    };
  }]);

  /* eslint-disable angular/timeout-service */

  var doc$1 = window.document;

  function fixQuery(s) {
    // corrects IDs that aren't valid CSS-style IDs
    return s.replace(/#([^a-z][-\w]+)/gi, '[id="$1"]');
  }

  function querySelector(s) {
    return isString(s) ? doc$1.querySelector(fixQuery(s)) : s;
  }

  var WINDOW_EVT_RESIZE = 'window:resize';

  var windowEventHelperModule = angular.module('Q.helpers.window-event-helper', []).run(['$rootScope', '$document', '$window', '$timeout', function ($rootScope, $document, $window, $timeout) {
    function _configEvents(element, prefix, events) {
      events.forEach(function (evtName) {
        var names = evtName.split(';');
        element.on(names[0], function (event) {
          names.forEach(function (n) {
            $rootScope.$broadcast(prefix + ':' + n, event);
          });
        });
      });
    }

    _configEvents(angular.element($window), 'window', ['resize', 'focus', 'blur', 'orientationchange;resize', 'message']);

    _configEvents($document, 'document', ['focusin']);

    // Special case for focus out, because we usually want to see if the active element changed, which needs a delay
    $document.on('focusout', function (event) {
      $rootScope.$broadcast('document:focusout', event);
      $timeout(function () {
        $rootScope.$broadcast('document:focusoutActiveElement', event, $document[0].activeElement);
      }, 0);
    });

    // set up document focus events based on polling
    var doc = $document[0];
    if (angular.isFunction(doc.hasFocus)) {
      var docHadFocus = doc.hasFocus();
      $window.setInterval(function checkFocus() {
        if (docHadFocus !== doc.hasFocus()) {
          docHadFocus = doc.hasFocus();
          $rootScope.$applyAsync(function () {
            $rootScope.$broadcast('document:' + (docHadFocus ? 'focus' : 'blur'));
          });
        }
      }, 250);
    }
  }]);

  var activateOnScrollComponentModule = angular.module('Q.components.activate-on-scroll', [windowEventHelperModule]).directive('activateOnScroll', ['$window', '$timeout', function ($window, $timeout) {
    return {
      restrict: 'A',
      link: function link(scope, elem, attrs) {
        var scrollTargetSelector = attrs.scrollTarget || attrs.activateOnScroll;
        var scrollTarget = scrollTargetSelector ? document.querySelector(scrollTargetSelector) || $window : $window;
        var $scrollTarget = angular.element(scrollTarget);
        var relativeParent = attrs.relativeParent ? document.querySelector(attrs.relativeParent) : null;
        var $relativeParent = relativeParent ? angular.element(relativeParent) : null;
        var activeClass = attrs.activeClass || 'active';
        var debounceTimer = void 0;
        var scrollToScrolling = false;

        $scrollTarget.on('scroll', _onScroll);
        scope.$on('$destroy', function () {
          return $scrollTarget.off('scroll', _onScroll);
        });
        scope.$on(WINDOW_EVT_RESIZE, _onScroll);

        scope.$on('scrollTo.scrolling', function (evt, active) {
          if (!active) {
            _activate();
          }
          scrollToScrolling = active;
        });

        $timeout(_activate, 150);

        //// private functions

        function _onScroll() {
          if (scrollToScrolling || debounceTimer) return;
          debounceTimer = $timeout(function () {
            debounceTimer = null;
            _activate();
          }, 50);
          _activate();
        }

        function _activate() {
          var found = false;
          var scrollOffset = $scrollTarget.scrollTop();
          var el = void 0;

          // allow for things like fixed headers by specifying a relative parent
          if ($relativeParent) {
            scrollOffset += $relativeParent.offsetTop();
          }

          // Now loop through children, and figure out who's the first one on screen
          // by looking for the
          var children = elem.children();
          angular.forEach(children, function (child, i) {
            child = angular.element(child);
            // always clear classes first
            child.removeClass(activeClass);
            if (found) return;

            // now determine what our target ID is (we do it here so it can be set at a later time)
            el = _getActiveElement(child);
            // the + 2 gives us a 2px buffer, because we don't want to mark the active section if we're
            // on the edge between them.  Fixes a bug in scroll-to, as well.
            if (el && el.offsetTop() > scrollOffset + 2) {
              if (i > 0) {
                var activeEl = angular.element(children[i - 1]);
                if (!activeEl.attr('disable-activate')) {
                  activeEl.addClass(activeClass);
                }
                // disabling this for now, it causes too many obscure issues.
                // the only place it's _really_ useful is the KB, and even there it's probably not critical enough
                //if(!scrollToScrolling && lastActiveEl && lastActiveEl.attr('id') && $window.history && $window.history.replaceState) {
                //	$window.history.replaceState({}, '', $window.location.href.replace(/(#.*|$)/, '#') + lastActiveEl.attr('id'));
                //}
              }
              found = true;
            }
          });
          if (!found && children.length > 0) {
            angular.element(children[children.length - 1]).addClass(activeClass);
          }
        }

        function _getActiveElement(child) {
          var activeSelector = child.attr('linkTarget');
          var activeId = void 0;
          if (!activeSelector) {
            activeId = child.attr('href') || child.attr('scroll-to');
            if (!activeId) {
              var el = child.querySelector('a');
              activeId = el.length ? el.attr('href') || el.attr('scroll-to') : '';
            }
            activeSelector = activeId && activeId.replace(/.*#/, '#');
          }
          return activeSelector ? angular.element(querySelector(activeSelector)) : null;
        }
      }
    };
  }]);

  var scrollToComponentModule = angular.module('Q.components.scroll-to', []).directive('scrollTo', ['$window', 'scrollToElement', '$timeout', function ($window, scrollToElement, $timeout) {
    return {
      restrict: 'A',
      link: function link(scope, elem, attrs) {
        // used so we don't replace the history state on page load
        var initialLoad = false;

        elem.on('click', function (event) {
          var target = _getTarget(attrs);

          event.preventDefault();
          if (!initialLoad && _isAnchor(target) && $window.history && $window.history.replaceState) {
            $window.history.replaceState({}, '', $window.location.href.replace(/#.*/, '') + target);
          }
          initialLoad = false;

          scrollToElement({
            target: target,
            scrollTarget: attrs.scrollTarget,
            relativeParent: attrs.relativeParent
          });

          elem[0].blur();
        });

        var hash = $window.location.hash;

        $timeout(function () {
          // handle page-loads
          var target = _getTarget(attrs);
          if (_isAnchor(target) && hash === target) {
            initialLoad = true;
            $timeout(function () {
              return elem.triggerHandler('click');
            });
          }
        }, 250);
      }
    };

    //// private functions

    function _isAnchor(target) {
      return (/^#/.test(target)
      );
    }

    function _getTarget(attrs) {
      var target = attrs.scrollTo;
      if (!target) {
        target = attrs.href;
        if (target) {
          target = target.replace(/.*#/, '#');
        }
      }
      return target;
    }
  }]).directive('scrollHere', ['scrollToElement', '$timeout', function (scrollToElement, $timeout) {
    return {
      restrict: 'A',
      link: function link(scope, elem, attrs) {
        $timeout(function () {
          if (attrs.scrollHere && !scope.$eval(attrs.scrollHere)) {
            return;
          }
          scrollToElement({
            target: elem[0],
            scrollTarget: attrs.scrollTarget,
            relativeParent: attrs.relativeParent,
            offset: attrs.scrollOffset || 0,
            ignoreIfVisible: true
          });
        }, 250);
      }
    };
  }]).factory('preserveScroll', ['$timeout', function ($timeout) {
    return function (target, changeEvent) {
      var $target = angular.element(querySelector(target));
      var scrollParent = $target.scrollableParent();
      // determine current offset from top of parent frame
      var diff = $target.offsetTop() - scrollParent.scrollTop();

      // enable event to change
      var newTarget = changeEvent();
      $timeout(function () {
        // after a digest cycle, adjust the scroll so we don't appear to have changed
        if (newTarget) {
          target = newTarget;
        }
        // re-look up the node if necessary
        var $target = angular.element(querySelector(target));
        scrollParent.scrollTop($target.offsetTop() - diff);
      });
    };
  }]).factory('scrollToElement', ['$window', '$document', '$rootScope', '$q', function ($window, $document, $rootScope, $q) {
    var animFrame = void 0;

    /**
     * Scrolls to a target element
     * @param target {string|HTMLElement|angular.element} Element to scroll to (required)
     * @param scrollTarget {string|HTMLElement|angular.element?} Element to scroll. If not provided, determined automatically
     * @param relativeParent {string|HTMLElement|angular.element?} If provided, used to determine the top of the element for relatively positioned elements
     * @param ignoreIfVisible {boolean?} If true, don't scroll if the element is already visible
     * @param offset {number?} If provided, offset the final value by this much
     * @param center {boolean|number?} If true, center the item in the view. If a number, it should be between 0 and 1, and is used to offset the value by that %. .5 is centered, .25 is 1/4 from the top, etc.
     * @returns {*}
     */
    function scrollToElement(_ref) {
      var target = _ref.target,
          scrollTarget = _ref.scrollTarget,
          relativeParent = _ref.relativeParent,
          ignoreIfVisible = _ref.ignoreIfVisible,
          _ref$offset = _ref.offset,
          offset = _ref$offset === undefined ? 0 : _ref$offset,
          _ref$center = _ref.center,
          center = _ref$center === undefined ? false : _ref$center;

      if (animFrame) {
        $window.cancelAnimationFrame(animFrame);
        animFrame = null;
      }

      var _calculateScrollTo2 = _calculateScrollTo(target, scrollTarget, relativeParent, offset, center),
          $scrollTarget = _calculateScrollTo2.$scrollTarget,
          scrollOffset = _calculateScrollTo2.scrollOffset,
          scrollRelative = _calculateScrollTo2.scrollRelative,
          isVisible$$1 = _calculateScrollTo2.isVisible;

      if (!$scrollTarget || ignoreIfVisible && isVisible$$1 || !scrollRelative) {
        return $q.resolve(false);
      }

      var animTime = Math.min(500, Math.abs(scrollRelative));
      var start = Date.now();

      var deferred = $q.defer();

      $rootScope.$broadcast('scrollTo.scrolling', true);
      _animateScroll();

      return deferred.promise;

      //// private functions

      function _animateScroll() {
        var now = Date.now();
        var percentTime = (now - start) / animTime;
        var percentScroll = percentTime >= 1 ? 1 : 0.5 + Math.cos(percentTime * Math.PI - Math.PI) / 2;
        var currentScrollTo = scrollOffset + Math.ceil(percentScroll * scrollRelative);

        $scrollTarget.scrollTop(currentScrollTo);

        // continue until done
        if (percentScroll < 1) {
          animFrame = $window.requestAnimationFrame(_animateScroll);
        } else {
          $rootScope.$broadcast('scrollTo.scrolling', false);
          animFrame = null;
          deferred.resolve(true);
        }
      }
    }

    scrollToElement.query = _query;

    return scrollToElement;

    function _query(node) {
      return angular.isString(node) ? querySelector(node) : node;
    }

    function _calculateScrollTo(target, scrollTarget, relativeParent) {
      var offset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
      var center = arguments[4];

      target = _query(target);
      if (!target) return {};

      var $target = angular.element(target);
      var targetHeight = $target.offsetHeight();

      scrollTarget = scrollTarget ? _query(scrollTarget) : $target.scrollableParent()[0];
      relativeParent = relativeParent || scrollTarget;

      var $scrollTarget = angular.element(scrollTarget);
      var scrollTargetHeight = $scrollTarget.offsetHeight();
      var relativeParentTop = 0;
      if (relativeParent && relativeParent !== $window) {
        relativeParentTop = angular.element(_query(relativeParent)).offsetTop();
      }
      if (offset && angular.isString(offset)) {
        offset = angular.element(_query(offset)).offsetHeight();
      }

      // calculate the final scroll value
      var scrollTo = $target.offsetTop() - relativeParentTop - $scrollTarget.getFixedNodeOffsets();
      if (center && targetHeight < scrollTargetHeight) {
        var centeringOffsetRatio = angular.isNumber(center) ? center : 0.5;
        // try to center the node in the view
        scrollTo -= (scrollTargetHeight - targetHeight) * centeringOffsetRatio;
      }
      scrollTo -= offset;

      var scrollOffset = $scrollTarget.scrollTop();
      var scrollRelative = scrollTo - scrollOffset;
      var targetBottom = scrollTo + targetHeight;
      var scrollTargetBottom = scrollOffset + scrollTargetHeight;
      var isVisible$$1 = scrollTo > scrollOffset && targetBottom < scrollTargetBottom;

      return {
        scrollTo: scrollTo,
        scrollOffset: scrollOffset,
        scrollRelative: scrollRelative,
        $scrollTarget: $scrollTarget,
        isVisible: isVisible$$1
      };
    }
  }]);

  var bubbleDialogTemplate = "<div class=\"bubble-dialog popover {{::className}} {{::positionClass}} {{::closeable?'bubble-dialog-closeable':''}}\"> <div class=\"arrow\"></div> <div class=\"popover-inner\"> <div class=\"popover-close\" ng-click=\"remove()\"></div> <div class=\"popover-title\" ng-if=\"title\">{{title}}</div> <div class=\"popover-content\"> <div class=\"content\" ng-bind-html=\"content\" ng-if=\"!contentTemplate\"></div> <div class=\"content\" compile-template=\"contentTemplate\" ng-if=\"contentTemplate\"></div> <div class=\"btn-container\" ng-if=\"buttons\"> <button ng-repeat=\"button in buttons\" class=\"{{button.className || 'btn btn-default'}}\" ng-click=\"button.resolve($event)\"> {{button.title}} </button> </div> </div> </div> </div> ";

  var bubbleDialogMenuTemplate = "<div class=\"bubble-dialog popover bubble-dialog-menu {{::className}} {{::positionClass}}\"> <div class=\"arrow\"></div> <div class=\"popover-inner\" compile-template=\"menu\"></div> </div> ";

  /* eslint-disable angular/timeout-service */

  var MutationObserver = window.MutationObserver || window.webkitMutationObserver;

  var nodeChangeListenerServiceModule = angular.module('Q.services.node-change-listener', []).factory('nodeChangeListener', ['$window', function ($window) {
    /**
     * Listens to DOM changes on a given node using browser methods.
     *
     * @param node Node to listen on
     * @param fn {Function} Function to call on DOM changes
     * @returns {Function} Function to disconnect the listener
     */
    function listenForChanges(node, fn) {
      var stopListening = angular.noop;

      if (node instanceof angular.element) {
        node = node[0];
      }

      if (MutationObserver) {
        // listen for any subtree changes
        var mutationObserverOpts = {
          childList: true,
          characterData: true,
          attributes: true,
          subtree: true
        };
        var observer = new MutationObserver(function () {
          observer.disconnect();
          var event = new CustomEvent('MutationEvent');
          fn(event);
          observer.observe(node, mutationObserverOpts);
        });
        observer.observe(node, mutationObserverOpts);

        stopListening = function stopListening() {
          return observer.disconnect();
        };
      } else {
        var ignoringMutations = false;
        var subtreeDebounce = null;
        var subtreeTrigger = function subtreeTrigger(event) {
          if (subtreeDebounce) $window.clearTimeout(subtreeDebounce);
          subtreeDebounce = $window.setTimeout(function () {
            if (ignoringMutations) return;
            ignoringMutations = true;
            fn(event);
            subtreeDebounce = null;
            ignoringMutations = false;
          }, 10);
        };

        var $node = angular.element(node);
        $node.on('DOMSubtreeModified', subtreeTrigger);

        stopListening = function stopListening() {
          return $node.off('DOMSubtreeModified', subtreeTrigger);
        };
      }

      return stopListening;
    }

    return {
      listen: listenForChanges
    };
  }]);

  /**
   * From angular-ui UI.Layout
   */

  // broadcast when the layout is being resized (manually or otherwise)
  var UI_LAYOUT_EVT_RESIZE = 'ui.layout.resize';
  // broadcast after redrawing during manual resize
  var UI_LAYOUT_EVT_DRAW_COMPLETE = 'ui.layout.draw-complete';

  var UI_LAYOUT_AUTO_SIZE = 'auto';

  var uiLayoutComponentModule = angular.module('Q.components.ui-layout', [windowEventHelperModule]).controller('uiLayoutCtrl', ['$scope', '$attrs', '$element', '$timeout', 'LayoutContainer', 'Layout', '$log', function uiLayoutCtrl($scope, $attrs, $element, $timeout, LayoutContainer, Layout, $log) {
    var ctrl = this;
    var opts = angular.extend({}, $scope.$eval($attrs.uiLayout), $scope.$eval($attrs.options));
    var numOfSplitbars = 0;
    //var cache = {};
    var animationFrameRequested = void 0;
    var lastPos = void 0;

    // regex to verify size is properly set to pixels or percent
    var sizePattern = /\d+\s*(px|%)\s*$/i;

    Layout.addLayout(ctrl);

    ctrl.containers = [];
    ctrl.movingSplitbar = null;
    ctrl.bounds = $element[0].getBoundingClientRect();
    ctrl.isUsingColumnFlow = opts.flow === 'column';
    ctrl.sizeProperties = !ctrl.isUsingColumnFlow ? {
      sizeProperty: 'height',
      offsetSize: 'offsetHeight',
      offsetPos: 'top',
      flowProperty: 'top',
      oppositeFlowProperty: 'bottom',
      mouseProperty: 'clientY',
      flowPropertyPosition: 'y'
    } : {
      sizeProperty: 'width',
      offsetSize: 'offsetWidth',
      offsetPos: 'left',
      flowProperty: 'left',
      oppositeFlowProperty: 'right',
      mouseProperty: 'clientX',
      flowPropertyPosition: 'x'
    };

    $element
    // Force the layout to fill the parent space
    // fix no height layout...
    .addClass('stretch')
    // set the layout css class
    .addClass('ui-layout-' + (opts.flow || 'row'));

    // Initial global size definition
    opts.sizes = opts.sizes || [];
    opts.maxSizes = opts.maxSizes || [];
    opts.minSizes = opts.minSizes || [];
    opts.dividerSize = opts.dividerSize === undefined ? 10 : opts.dividerSize;
    ctrl.opts = opts;

    $scope.updateDisplay = function () {
      ctrl.calculate();
    };

    var debounceEvent = void 0;

    function draw() {
      var position = ctrl.sizeProperties.flowProperty;
      var dividerSize = parseInt(opts.dividerSize);
      var elementSize = $element[0][ctrl.sizeProperties.offsetSize];

      if (ctrl.movingSplitbar !== null) {
        var splitbarIndex = ctrl.containers.indexOf(ctrl.movingSplitbar);
        var nextSplitbarIndex = splitbarIndex + 2 < ctrl.containers.length ? splitbarIndex + 2 : null;

        if (splitbarIndex > -1) {
          var processedContainers = ctrl.processSplitbar(ctrl.containers[splitbarIndex]);
          var beforeContainer = processedContainers.beforeContainer;
          var afterContainer = processedContainers.afterContainer;

          // calculate container positons
          var difference = ctrl.movingSplitbar[position] - lastPos;
          var newPosition = ctrl.movingSplitbar[position] - difference;

          // Keep the bar in the window (no left/top 100%)
          newPosition = Math.min(elementSize - dividerSize, newPosition);

          // Keep the bar from going past the previous element min/max values
          if (angular.isNumber(beforeContainer.beforeMinValue) && newPosition < beforeContainer.beforeMinValue) {
            newPosition = beforeContainer.beforeMinValue;
          }
          if (angular.isNumber(beforeContainer.beforeMaxValue) && newPosition > beforeContainer.beforeMaxValue) {
            newPosition = beforeContainer.beforeMaxValue;
          }

          // Keep the bar from going past the next element min/max values
          if (afterContainer !== null && angular.isNumber(afterContainer.afterMinValue) && newPosition > afterContainer.afterMinValue - dividerSize) {
            newPosition = afterContainer.afterMinValue - dividerSize;
          }
          if (afterContainer !== null && angular.isNumber(afterContainer.afterMaxValue) && newPosition < afterContainer.afterMaxValue) {
            newPosition = afterContainer.afterMaxValue;
          }

          // resize the before container
          beforeContainer.size = newPosition - beforeContainer[position];
          // store the current value to preserve this size during onResize
          beforeContainer.previousSize = beforeContainer.size;

          // update after container position
          var oldAfterContainerPosition = afterContainer[position];
          afterContainer[position] = newPosition + dividerSize;

          //update after container size if the position has changed
          if (afterContainer[position] !== oldAfterContainerPosition) {
            afterContainer.size = nextSplitbarIndex !== null ? oldAfterContainerPosition + afterContainer.size - (newPosition + dividerSize) : elementSize - (newPosition + dividerSize);
            // store the current value to preserve this size during onResize
            afterContainer.previousSize = afterContainer.size;
          }

          // move the splitbar
          ctrl.movingSplitbar[position] = newPosition;

          // broadcast an event that resize happened (debounced to 50ms)
          if (debounceEvent) $timeout.cancel(debounceEvent);
          debounceEvent = $timeout(function () {
            $scope.$broadcast(UI_LAYOUT_EVT_RESIZE, 'draw');
            $scope.$emit(UI_LAYOUT_EVT_DRAW_COMPLETE);
            debounceEvent = null;
          }, 50);
        }
      }

      //Enable a new animation frame
      animationFrameRequested = null;
    }

    function offset(element) {
      var rawDomNode = element[0];
      var body = document.documentElement || document.body;
      var scrollX = window.pageXOffset || body.scrollLeft;
      var scrollY = window.pageYOffset || body.scrollTop;
      var clientRect = rawDomNode.getBoundingClientRect();
      var x = clientRect.left + scrollX;
      var y = clientRect.top + scrollY;
      return { left: x, top: y };
    }

    /**
     * Returns the current value for an option
     * @param  option   The option to get the value for
     * @return The value of the option. Returns null if there was no option set.
     */
    function optionValue(option) {
      if (angular.isNumber(option) || angular.isString(option) && option.match(sizePattern)) {
        return option;
      } else {
        return null;
      }
    }

    //================================================================================
    // Public Controller Functions
    //================================================================================
    ctrl.mouseDownHandler = function (splitbar) {
      // only trigger when left mouse button is pressed:
      $element.addClass('ui-layout-resizing');
      ctrl.movingSplitbar = splitbar;
      ctrl.processSplitbar(splitbar);
    };
    ctrl.mouseUpHandler = function () {
      $element.removeClass('ui-layout-resizing');
      ctrl.movingSplitbar = null;
    };

    ctrl.mouseMoveHandler = function (mouseEvent) {
      var mousePos = mouseEvent[ctrl.sizeProperties.mouseProperty] || mouseEvent.originalEvent && mouseEvent.originalEvent[ctrl.sizeProperties.mouseProperty] || (mouseEvent.targetTouches ? mouseEvent.targetTouches[0][ctrl.sizeProperties.mouseProperty] : 0);

      lastPos = mousePos - offset($element)[ctrl.sizeProperties.offsetPos];

      //Cancel previous rAF call
      if (animationFrameRequested) {
        window.cancelAnimationFrame(animationFrameRequested);
      }

      //TODO: cache layout values

      //Animate the page outside the event
      animationFrameRequested = window.requestAnimationFrame(draw);
    };

    /**
     * Returns the min and max values of the ctrl.containers on each side of the container submitted
     * @param container
     * @returns {*}
     */
    ctrl.processSplitbar = function (container) {
      var index = ctrl.containers.indexOf(container);

      var setValues = function setValues(container) {
        var start = container[ctrl.sizeProperties.flowProperty];
        var end = container[ctrl.sizeProperties.flowProperty] + container.size;

        container.beforeMinValue = angular.isNumber(container.minSize) ? start + container.minSize : start;
        container.beforeMaxValue = angular.isNumber(container.maxSize) ? start + container.maxSize : null;

        container.afterMinValue = angular.isNumber(container.minSize) ? end - container.minSize : end;
        container.afterMaxValue = angular.isNumber(container.maxSize) ? end - container.maxSize : null;
      };

      //verify the container was found in the list
      if (index > -1) {
        var beforeContainer = index > 0 ? ctrl.containers[index - 1] : null;
        var afterContainer = index + 1 <= ctrl.containers.length ? ctrl.containers[index + 1] : null;

        if (beforeContainer !== null) setValues(beforeContainer);
        if (afterContainer !== null) setValues(afterContainer);

        return {
          beforeContainer: beforeContainer,
          afterContainer: afterContainer
        };
      }

      return null;
    };

    /**
     * Checks if a string has a percent symbol in it.
     * @param num
     * @returns {boolean}
     */
    ctrl.isPercent = function (num) {
      return !!(num && angular.isString(num) && num.indexOf('%') > -1);
    };

    /**
     * Converts a number to pixels from percent.
     * @param size
     * @param parentSize
     * @returns {number}
     */
    ctrl.convertToPixels = function (size, parentSize) {
      return Math.floor(parentSize * (parseInt(size) / 100));
    };

    var isAuto = function isAuto(i) {
      return opts.sizes[i] === UI_LAYOUT_AUTO_SIZE;
    };

    /**
     * Sets the size for each container initially and on window resize.
     */
    ctrl.calculate = function () {
      var dividerSize = parseInt(opts.dividerSize);
      var elementSize = $element[0].getBoundingClientRect()[ctrl.sizeProperties.sizeProperty];
      var originalSize = elementSize - dividerSize * numOfSplitbars;
      var containers = ctrl.containers;
      var containerCount = containers.length;

      if (originalSize > 0 && containerCount > 0 && $element.children().length > 0) {
        var availableSize = originalSize;
        var usedSpace = 0;
        var numOfAutoContainers = 0;
        var lastAuto = void 0;
        var autoSize = void 0;
        var sizes = opts.sizes;
        var minSizes = opts.minSizes;
        var maxSizes = opts.maxSizes;

        // calculate sizing for containers
        for (var i = 0; i < containerCount; i++) {
          if (!LayoutContainer.isSplitbar(containers[i])) {
            var c = containers[i];
            if (!isAuto(i)) {
              sizes[i] = c.isCentral ? UI_LAYOUT_AUTO_SIZE : optionValue(c.previousSize) || UI_LAYOUT_AUTO_SIZE;
            }
            minSizes[i] = optionValue(c.minSize);
            maxSizes[i] = optionValue(c.maxSize);

            if (!isAuto(i)) {
              if (ctrl.isPercent(sizes[i])) {
                sizes[i] = ctrl.convertToPixels(sizes[i], originalSize);
              } else {
                sizes[i] = parseInt(sizes[i]);
              }
            }

            if (minSizes[i] !== null) {
              if (ctrl.isPercent(minSizes[i])) {
                minSizes[i] = ctrl.convertToPixels(minSizes[i], originalSize);
              } else {
                minSizes[i] = parseInt(minSizes[i]);
              }

              // don't allow the container size to be smaller than the minSize
              if (sizes[i] < minSizes[i]) sizes[i] = minSizes[i];
            }

            if (maxSizes[i] !== null) {
              if (ctrl.isPercent(maxSizes[i])) {
                maxSizes[i] = ctrl.convertToPixels(maxSizes[i], originalSize);
              } else {
                maxSizes[i] = parseInt(maxSizes[i]);
              }

              // don't allow the container size to be larger than the maxSize
              if (sizes[i] > maxSizes[i]) sizes[i] = maxSizes[i];
            }

            if (isAuto(i)) {
              numOfAutoContainers++;
            } else {
              availableSize -= sizes[i];
            }
          }
        }

        // calculate initial autoSize
        autoSize = numOfAutoContainers > 0 ? Math.floor(availableSize / numOfAutoContainers) : 0;

        // Now scan again to check for any auto container outside it's min/max limits
        for (var _i = 0; _i < containerCount; _i++) {
          if (!LayoutContainer.isSplitbar(containers[_i]) && isAuto(_i)) {
            var maxSize = maxSizes[_i];
            var minSize = minSizes[_i];
            if (maxSize && maxSize < autoSize) {
              // adjust available size if the container would be too wide
              availableSize -= maxSize;
              numOfAutoContainers--;
            } else if (minSize && minSize > autoSize) {
              // adjust available size if the container would be too narrow
              // Note: this _could_ leave us with too much content for the space, so it might overflow
              //   this is likely preferable to crushing content
              availableSize -= minSize;
              numOfAutoContainers--;
            } else {
              // track the last truly auto container for the remainder
              lastAuto = _i;
            }
          }
        }

        // recalculate autosize in case we converted an autosize container
        autoSize = numOfAutoContainers > 0 ? Math.floor(availableSize / numOfAutoContainers) : 0;
        /*
         * When the parent size is odd, rounding down the `autoSize` leaves a remainder.
         * This remainder is added to the last auto-sized container in a layout.
         */
        var remainder = Math.max(0, availableSize - autoSize * numOfAutoContainers);
        for (var _i2 = 0; _i2 < containerCount; _i2++) {
          var _c = containers[_i2];
          _c[ctrl.sizeProperties.flowProperty] = usedSpace;
          _c.maxSize = maxSizes[_i2];
          _c.minSize = minSizes[_i2];

          if (!LayoutContainer.isSplitbar(_c)) {
            var newSize = void 0;
            if (isAuto(_i2)) {
              newSize = Math.min(_c.maxSize || Infinity, Math.max(_c.minSize || 0, autoSize));
              // add the rounding down remainder to the last auto-sized container in the layout
              if (_i2 === lastAuto) {
                newSize += remainder;
              }
            } else {
              newSize = sizes[_i2];
              if (availableSize < 0) {
                // the first fixed container must lose some width if we have negative space due to min/max
                newSize = Math.min(_c.maxSize || Infinity, Math.max(_c.minSize || 0, newSize + availableSize));
                availableSize = 0;
              }
            }

            _c.size = newSize !== null ? newSize : autoSize;
          } else {
            _c.size = dividerSize;
          }

          usedSpace += _c.size;
        }
      }

      if (debounceEvent) $timeout.cancel(debounceEvent);
      debounceEvent = $timeout(function () {
        $scope.$broadcast(UI_LAYOUT_EVT_RESIZE, 'calculate');
        debounceEvent = null;
      }, 50);
    };

    /**
     * Adds a container to the list of layout ctrl.containers.
     * @param container The container to add
     */
    ctrl.addContainer = function (container) {
      var index = ctrl.indexOfElement(container.element);
      if (!angular.isDefined(index) || index < 0 || ctrl.containers.length < index) {
        $log.error('Invalid index to add container; i=' + index + ', len=', ctrl.containers.length);
        return;
      }

      if (LayoutContainer.isSplitbar(container)) {
        numOfSplitbars++;
      }

      container.index = index;
      ctrl.containers.splice(index, 0, container);

      ctrl.calculate();
    };

    /**
     * Remove a container from the list of layout ctrl.containers.
     * @param  container
     */
    ctrl.removeContainer = function (container) {
      var index = ctrl.containers.indexOf(container);
      if (index >= 0) {
        if (!LayoutContainer.isSplitbar(container)) {
          if (ctrl.containers.length > 2) {
            // Assume there's a sidebar between each container
            // We need to remove this container and the sidebar next to it
            if (index === ctrl.containers.length - 1) {
              // We're removing the last element, the side bar is on the left
              ctrl.containers[index - 1].element.remove();
            } else {
              // The side bar is on the right
              ctrl.containers[index + 1].element.remove();
            }
          }
        } else {
          numOfSplitbars--;
        }

        // Need to re-check the index, as a side bar may have been removed
        var newIndex = ctrl.containers.indexOf(container);
        if (newIndex >= 0) {
          ctrl.containers.splice(newIndex, 1);
          ctrl.opts.maxSizes.splice(newIndex, 1);
          ctrl.opts.minSizes.splice(newIndex, 1);
          ctrl.opts.sizes.splice(newIndex, 1);
        }
        ctrl.calculate();
      } else {
        $log.error('removeContainer for container that did not exist!');
      }
    };

    /**
     * Returns an array of layout ctrl.containers.
     * @returns {Array}
     */
    ctrl.getContainers = function () {
      return ctrl.containers;
    };

    /**
     * Returns the container object of the splitbar that is before the one passed in.
     * @param currentSplitbar
     */
    ctrl.getPreviousSplitbarContainer = function (currentSplitbar) {
      if (LayoutContainer.isSplitbar(currentSplitbar)) {
        var currentSplitbarIndex = ctrl.containers.indexOf(currentSplitbar);
        var previousSplitbarIndex = currentSplitbarIndex - 2;
        if (previousSplitbarIndex >= 0) {
          return ctrl.containers[previousSplitbarIndex];
        }
        return null;
      }
      return null;
    };

    /**
     * Returns the container object of the splitbar that is after the one passed in.
     * @param currentSplitbar
     */
    ctrl.getNextSplitbarContainer = function (currentSplitbar) {
      if (LayoutContainer.isSplitbar(currentSplitbar)) {
        var currentSplitbarIndex = ctrl.containers.indexOf(currentSplitbar);
        var nextSplitbarIndex = currentSplitbarIndex + 2;
        if (currentSplitbarIndex > 0 && nextSplitbarIndex < ctrl.containers.length) {
          return ctrl.containers[nextSplitbarIndex];
        }
        return null;
      }
      return null;
    };

    /**
     * Checks whether the container before this one is a split bar
     * @param  {container}  container The container to check
     * @return {Boolean}    true if the element before is a splitbar, false otherwise
     */
    ctrl.hasSplitbarBefore = function (container) {
      var index = ctrl.containers.indexOf(container);
      if (1 <= index) {
        return LayoutContainer.isSplitbar(ctrl.containers[index - 1]);
      }

      return false;
    };

    /**
     * Checks whether the container after this one is a split bar
     * @param  {container}  container The container to check
     * @return {Boolean}    true if the element after is a splitbar, false otherwise
     */
    ctrl.hasSplitbarAfter = function (container) {
      var index = ctrl.containers.indexOf(container);
      if (index < ctrl.containers.length - 1) {
        return LayoutContainer.isSplitbar(ctrl.containers[index + 1]);
      }

      return false;
    };

    /**
     * Checks whether the passed in element is a ui-layout type element.
     * @param  {element}  element The element to check
     * @return {Boolean}          true if the element is a layout element, false otherwise.
     */
    ctrl.isLayoutElement = function (element) {
      return element.hasAttribute('ui-layout-container') || element.hasAttribute('ui-splitbar') || element.nodeName === 'UI-LAYOUT-CONTAINER';
    };

    /**
     * Retrieve the index of an element within it's parents context.
     * @param  {element} element The element to get the index of
     * @return {int}             The index of the element within it's parent
     */
    ctrl.indexOfElement = function (element) {
      var parent = element.parent();
      var children = parent.children();
      var containerIndex = 0;
      for (var i = 0; i < children.length; i++) {
        var child = children[i];
        if (ctrl.isLayoutElement(child)) {
          if (element[0] === children[i]) {
            return containerIndex;
          }
          containerIndex++;
        }
      }
      return -1;
    };

    return ctrl;
  }]).directive('uiLayout', ['$timeout', function ($timeout) {
    return {
      restrict: 'AE',
      controller: 'uiLayoutCtrl',
      require: ['^uiLayout', '?rememberUi'],
      link: function link(scope, element, attrs, _ref) {
        var _ref2 = slicedToArray(_ref, 2),
            uiLayoutCtrl = _ref2[0],
            rememberUiCtrl = _ref2[1];

        scope.$watch(function () {
          return element[0][uiLayoutCtrl.sizeProperties.offsetSize];
        }, function () {
          uiLayoutCtrl.calculate();
        });

        function onResize() {
          scope.$evalAsync(function () {
            uiLayoutCtrl.calculate();
          });
        }

        scope.$on(WINDOW_EVT_RESIZE, onResize);

        // enable storing sizes to localstorage
        $timeout(function () {
          if (rememberUiCtrl) {
            // attempt to reload the previous setup
            var sizes = rememberUiCtrl.retrieve();
            if (sizes && angular.isArray(sizes)) {
              _writeBackSizes(sizes);
              // force an update
              uiLayoutCtrl.calculate();
            }

            scope.$on(UI_LAYOUT_EVT_RESIZE, function (evt, method) {
              var total = element[0].getBoundingClientRect()[uiLayoutCtrl.sizeProperties.sizeProperty];

              var sizes = uiLayoutCtrl.opts.sizes.map(function (s, i) {
                var pctSize = Math.min(100, 100 * (uiLayoutCtrl.containers[i].size + 10) / total);
                return s !== 'auto' ? pctSize : s;
              });
              if (sizes.length) {
                rememberUiCtrl.store(sizes);

                // when the user makes an adjustment, we replace the current attribute sizes with
                // percentages, so window resizes work
                if (method !== 'calculate') {
                  _writeBackSizes(sizes);
                }
              }
            });
          }
        });

        // Writes the current sizes as percentages back onto the child elements
        function _writeBackSizes(sizes) {
          uiLayoutCtrl.containers.forEach(function (c, i) {
            // ignore splitter bars, auto-sized panes, and completely hidden panes
            if (i % 2 === 0 && sizes[i] !== 'auto' && sizes[i] !== 0) {
              c.element.attr('size', Math.min(100, sizes[i]) + '%');
              c.previousSize = sizes[i] + '%';
            }
          });
        }
      }
    };
  }]).directive('uiSplitbar', ['LayoutContainer', function (LayoutContainer) {
    // Get all the page.
    var htmlElement = angular.element(document.body.parentElement);

    return {
      restrict: 'EAC',
      require: '^uiLayout',
      scope: {},

      link: function link(scope, element, attrs, ctrl) {
        element.addClass('stretch');
        element.addClass('ui-splitbar');

        var animationClass = ctrl.isUsingColumnFlow ? 'animate-column' : 'animate-row';
        element.addClass(animationClass);

        scope.splitbar = LayoutContainer.Splitbar();
        scope.splitbar.element = element;

        element.on('mousedown touchstart', function handleMouseDown(e) {
          if (e.button === 0 || e.type === 'touchstart') {
            // only trigger when left mouse button is pressed:
            e.preventDefault();
            e.stopPropagation();

            ctrl.mouseDownHandler(scope.splitbar);

            htmlElement.on('mousemove touchmove', handleMouseMove);
            return false;
          }
        });

        function handleMouseMove(event) {
          scope.$apply(function () {
            return ctrl.mouseMoveHandler(event);
          });
        }

        function handleMouseUp() {
          scope.$apply(ctrl.mouseUpHandler);
          htmlElement.off('mousemove touchmove', handleMouseMove);
        }

        htmlElement.on('mouseup touchend', handleMouseUp);

        scope.$watch('splitbar.size', function (newValue) {
          element.css(ctrl.sizeProperties.sizeProperty, newValue + 'px');
        });

        scope.$watch('splitbar.' + ctrl.sizeProperties.flowProperty, function (newValue) {
          element.css(ctrl.sizeProperties.flowProperty, newValue + 'px');
        });

        //Add splitbar to layout container list
        ctrl.addContainer(scope.splitbar);

        element.on('$destroy', function () {
          ctrl.removeContainer(scope.splitbar);
          htmlElement.off('mouseup touchend', handleMouseUp);
          htmlElement.off('mousemove touchmove', handleMouseMove);
          scope.$evalAsync();
        });
      }
    };
  }]).directive('uiLayoutContainer', ['LayoutContainer', '$compile', function (LayoutContainer, $compile) {
    return {
      restrict: 'AE',
      require: '^uiLayout',
      scope: {
        resizable: '=',
        size: '@',
        minSize: '@',
        maxSize: '@'
      },

      compile: function compile() {
        return {
          pre: function pre(scope, element, attrs, ctrl) {
            scope.container = LayoutContainer.Container();
            scope.container.element = element;
            scope.container.id = element.attr('id') || null;
            scope.container.layoutId = ctrl.id;
            scope.container.isCentral = attrs.uiLayoutContainer === 'central';

            if (angular.isDefined(scope.resizable)) {
              scope.container.resizable = scope.resizable;
            }
            scope.container.size = scope.size;
            scope.container.previousSize = scope.size;
            scope.container.minSize = scope.minSize;
            scope.container.maxSize = scope.maxSize;
            ctrl.addContainer(scope.container);

            element.on('$destroy', function () {
              ctrl.removeContainer(scope.container);
              scope.$evalAsync();
            });
          },
          post: function post(scope, element, attrs, ctrl) {
            element.addClass('stretch');
            element.addClass('ui-layout-container');

            var animationClass = ctrl.isUsingColumnFlow ? 'animate-column' : 'animate-row';
            element.addClass(animationClass);

            scope.$watch('container.size', function (newValue) {
              element.css(ctrl.sizeProperties.sizeProperty, newValue + 'px');
              if (newValue === 0) {
                element.addClass('ui-layout-hidden');
              } else {
                element.removeClass('ui-layout-hidden');
              }
            });

            scope.$watch('container.' + ctrl.sizeProperties.flowProperty, function (newValue) {
              element.css(ctrl.sizeProperties.flowProperty, newValue + 'px');
            });

            //TODO: add ability to disable auto-adding a splitbar after the container
            var parent = element.parent();
            var children = parent.children();
            var index = ctrl.indexOfElement(element);
            var splitbar = angular.element('<div ui-splitbar></div>');
            if (0 < index && !ctrl.hasSplitbarBefore(scope.container)) {
              angular.element(children[index - 1]).after(splitbar);
              $compile(splitbar)(scope);
            } else if (index < children.length - 1) {
              element.after(splitbar);
              $compile(splitbar)(scope);
            }
          }
        };
      }
    };
  }]).factory('Layout', function () {
    var layouts = [];

    return {
      addLayout: function addLayout(ctrl) {
        ctrl.id = layouts.length;
        layouts.push(ctrl);
      }
    };
  }).factory('LayoutContainer', function () {
    function BaseContainer() {
      /**
       * Stores element's id if provided
       * @type {string}
       */
      this.id = null;

      /**
       * Id of the parent layout
       * @type {number}
       */
      this.layoutId = null;

      /**
       * Central container that is always resized
       * @type {boolean}
       */
      this.isCentral = false;

      /**
       * actual size of the container, which is changed on every updateDisplay
       * @type {any}
       */
      this.size = UI_LAYOUT_AUTO_SIZE;

      /**
       * cache for the last uncollapsed size
       * @type {any}
       */
      this.previousSize = null;

      this.maxSize = null;
      this.minSize = null;
      this.resizable = true;
      this.element = null;
    }

    // Splitbar container
    function SplitbarContainer() {
      this.size = 10;
      this.left = 0;
      this.top = 0;
      this.element = null;
    }

    return {
      Container: function Container(initialSize) {
        return new BaseContainer(initialSize);
      },
      Splitbar: function Splitbar() {
        return new SplitbarContainer();
      },
      isSplitbar: function isSplitbar(container) {
        return container instanceof SplitbarContainer;
      }
    };
  });

  /* eslint-disable angular/timeout-service */

  var scrollMonitorServiceModule = angular.module('Q.services.scroll-monitor-service', [nodeChangeListenerServiceModule, windowEventHelperModule])

  /**
   * A service to make it easier to monitor scrolling and perform updates based on it.
   *
   * The service reduces event listeners by grouping scroll listeners per item, and also sharing a single
   * window.resize listener across all scroll listeners.
   *
   * The individual node scroll listeners can further benefit by including an optional element with the event
   * listener.  In this case, the single onScroll event will also update whether or not the item is visible,
   * and set it on the scroll listener return object.
   *
   */
  .factory('scrollMonitorService', ['$document', '$window', 'nodeChangeListener', '$rootScope', '$timeout', '$log', function ($document, $window, nodeChangeListener, $rootScope, $timeout, $log) {
    var scrollListeners = [];
    var doc = $document[0];

    /**
     * Creates a Listener for scroll-related events on a given viewport (DOM node or $window)
     */

    var Listener = function () {
      /**
       * Create a new Listener object
       * @param viewport {string|HTMLElement} The viewport on which we want to listen, defaults to window
       */
      function Listener(viewport) {
        var _this = this;

        classCallCheck(this, Listener);

        this.viewport = viewport;
        this.$viewport = angular.element(viewport);
        this.scrollWatchers = [];
        this.lastScrollTop = 0;
        this.lastHeight = 0;
        this.$destroyed = false;

        this.scrollTrigger = this.triggerUpdate.bind(this);
        this.$viewport.on('scroll touchmove', this.scrollTrigger);
        // ensure we always clean up if the dom node is destroyed
        this.$viewport.on('$destroy', function () {
          return _this.destroy();
        });

        // for non-window-level watches, we also look for DOM changes
        // otherwise, the resize event should be good enough
        if (viewport.nodeType) {
          this.nodeChangeListenerStop = nodeChangeListener.listen(viewport, function (event) {
            _this.triggerUpdate(event, true);
          });
        }

        scrollListeners.push(this);
      }

      /**
       * Trigger an update to all registered scrollWatchers
       * The goal with this design was to minimize calculation of the same data as much as possible.
       * If we have hundreds of event listeners, we don't want to perform the same work looking them up
       * every time.
       *
       * @param {Event} event The Event object for this update
       * @param {boolean} forceUpdate If true, forces an update regardless of scroll or height changes
       */


      createClass(Listener, [{
        key: 'triggerUpdate',
        value: function triggerUpdate(event, forceUpdate) {
          if (this.$destroyed) return;

          var viewport = this.$viewport;
          var viewportScrollTop = viewport.scrollTop();
          var viewportHeight = viewport.offsetHeight();

          if (forceUpdate !== true && viewportScrollTop === this.lastScrollTop && viewportHeight === this.lastHeight) return;

          this.lastScrollTop = viewportScrollTop;
          this.lastHeight = viewportHeight;

          var viewportTop = this.$viewport.offsetTop();

          var len = this.scrollWatchers.length;
          var i = len - 1;
          var sw = void 0;
          var elementTop = void 0;
          var elementHeight = void 0;
          var data = void 0;

          for (; i >= 0; i--) {
            if (viewport.length === 0) {
              $log.error("Invariant violation: expected viewport[0] to be defined but it wasn't");
              continue;
            }

            data = {
              viewport: viewport,
              viewportTop: viewportTop,
              viewportHeight: viewportHeight,
              viewportScrollTop: viewportScrollTop,
              viewportScrollHeight: viewport[0].scrollHeight
            };
            sw = this.scrollWatchers[i];
            if (sw) {
              if (sw.$elem) {
                // note whether the element is visible
                elementTop = sw.$elem.offsetTop();
                elementHeight = sw.elem.offsetHeight;
                data.element = sw.elem;
                data.elementTop = elementTop;
                data.elementHeight = elementHeight;
                Listener._setIsVisible(viewportTop, viewportHeight, viewportScrollTop, sw, data);
              }
              sw.notify(event, data);
            }
          }
        }

        /**
         * Mainly used to set the initial isVisible value on a ScrollWatcher, but it can also be used to
         * update the isVisible value out-of-band
         *
         * @param scrollWatcher
         */

      }, {
        key: 'setIsVisible',
        value: function setIsVisible(scrollWatcher) {
          Listener._setIsVisible(this.$viewport.offsetTop(), this.$viewport.offsetHeight(), this.$viewport.scrollTop(), scrollWatcher, {});
        }
      }, {
        key: 'addScrollWatcher',
        value: function addScrollWatcher(scrollWatcher) {
          var _this2 = this;

          if (this.$destroyed) return;
          this.scrollWatchers.push(scrollWatcher);
          $timeout.cancel(this._swAddedEvent);
          this._swAddedEvent = $timeout(function () {
            _this2.triggerUpdate(new CustomEvent('scrollWatcherAdded'), true);
          });
        }
      }, {
        key: 'removeScrollWatcher',
        value: function removeScrollWatcher(scrollWatcher) {
          var idx = this.scrollWatchers.indexOf(scrollWatcher);
          if (idx > -1) {
            this.scrollWatchers.splice(idx, 1);
            if (this.scrollWatchers.length === 0) {
              this.destroy();
            }
          }
        }
      }, {
        key: 'destroy',
        value: function destroy() {
          this.$viewport.off('scroll touchmove', this.scrollTrigger);
          if (this.nodeChangeListenerStop) {
            this.nodeChangeListenerStop();
          }
          this.scrollWatchers.length = 0;
          var idx = scrollListeners.indexOf(this);
          if (idx > -1) {
            scrollListeners.splice(idx, 1);
          }
          this.$destroyed = true;
        }
      }], [{
        key: '_setIsVisible',
        value: function _setIsVisible(viewportTop, viewportHeight, viewportScrollTop, scrollWatcher, data) {
          var elementTop = scrollWatcher.$elem.offsetTop() - viewportTop;
          var elementHeight = scrollWatcher.elem.offsetHeight;
          data.element = scrollWatcher.elem;
          data.elementTop = elementTop;
          data.elementHeight = elementHeight;
          scrollWatcher.isVisible = data.isVisible =
          // ensure the top is above the bottom of the viewport (with optional offset)
          viewportScrollTop + viewportHeight + scrollWatcher.offset > elementTop &&
          // ensure the bottoms is below the top of the viewport (with optional offset)
          viewportScrollTop - scrollWatcher.offset < elementTop + elementHeight;
        }
      }]);
      return Listener;
    }();

    var ScrollWatcher = function () {
      function ScrollWatcher(listener, callback, elem) {
        var offset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
        classCallCheck(this, ScrollWatcher);

        this.listener = listener;
        this.callback = callback;
        if (elem) {
          elem = _getElement(elem);
          this.elem = elem;
          this.$elem = angular.element(elem);
          this.offset = offset;
          this.update();
        }
      }

      createClass(ScrollWatcher, [{
        key: 'update',
        value: function update() {
          this.listener.setIsVisible(this);
        }
      }, {
        key: 'notify',
        value: function notify(event, data) {
          this.callback(event, data, this);
        }
      }, {
        key: 'destroy',
        value: function destroy() {
          this.listener.removeScrollWatcher(this);
        }
      }]);
      return ScrollWatcher;
    }();

    var svc = {
      /**
       * Adds a scroll listener to the provided viewport.
       *
       * @param viewport {HTMLElement|String} The node or selector for the node to watch
       * @param callback {function} The callback function on scroll (will be called with event, viewportData, and ScrollWatcher arguments
       * @param elem {HTMLElement|String} Optional element to monitor for visibility and offset information
       * @param offset Optional value for adding an offset when calculating whether the elem is visible or not
       * @returns {ScrollWatcher}
       */
      addListener: function addListener(viewport, callback) {
        var elem = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
        var offset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

        viewport = _getElement(viewport);
        var listener = scrollListeners.find(function (e) {
          return e.viewport === viewport;
        });
        if (!listener) {
          listener = new Listener(viewport);
        }

        var scrollWatcher = new ScrollWatcher(listener, callback, elem, offset);

        listener.addScrollWatcher(scrollWatcher);
        return scrollWatcher;
      },
      updateListeners: function updateListeners(event) {
        var i = 0;
        var len = scrollListeners.length;
        for (; i < len; i++) {
          if (!scrollListeners[i]) {
            $log.error("Invariant violation: scrollListeners[i] was supposed to be defined but wasn't");
            continue;
          }

          scrollListeners[i].triggerUpdate(event, true);
        }
      }
    };

    // on resize, fire all scroll listeners, but use only one listener for the whole application
    $rootScope.$on(WINDOW_EVT_RESIZE, function ($e, event) {
      return svc.updateListeners(event);
    });

    // also capture ui layout events
    $rootScope.$on(UI_LAYOUT_EVT_DRAW_COMPLETE, svc.updateListeners);

    return svc;

    //// private methods

    // returns a pure DOM element, or window if none provided
    function _getElement(elem) {
      if (!elem) return $window;

      if (angular.isString(elem)) {
        elem = doc.querySelector(elem);
      } else if (elem.length) {
        elem = elem[0];
      }

      if (!elem) {
        throw new Error('Unable to find element for scrollMonitorService: ' + elem);
      }

      if (elem.nodeType === 9) {
        elem = $window;
      }

      return elem;
    }
  }]);

  var uiBootstrapPositionModule = 'ui.bootstrap.position';

  var positionHelperModule = angular.module('Q.helpers.position-helper', [uiBootstrapPositionModule, scrollMonitorServiceModule]).factory('positionHelper', ['$window', '$document', '$position', 'scrollMonitorService', '$timeout', function ($window, $document, $position, scrollMonitorService, $timeout) {
    /**
     * Positions the popup around the element once
     *
     * @param element {Node} Element to position around
     * @param popup {Node} Popup element
     * @param position {String} position property
     * @param hasArrow {boolean} If true, align the nested arrow as well
     * @param setMinWidth {boolean} If true, set the min width to the element width
     * @param mousePosition {Object} If provided, the popup is oriented around the {pageX,pageY} properties
     */
    function positionPopup(element, popup) {
      var position = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'bottom';

      var _ref = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
          _ref$hasArrow = _ref.hasArrow,
          hasArrow = _ref$hasArrow === undefined ? false : _ref$hasArrow,
          _ref$setMinWidth = _ref.setMinWidth,
          setMinWidth = _ref$setMinWidth === undefined ? false : _ref$setMinWidth,
          _ref$mousePosition = _ref.mousePosition,
          mousePosition = _ref$mousePosition === undefined ? null : _ref$mousePosition;

      // don't move the popup if the element isn't attached
      if (!element.isVisible()) return;

      var popupPosition = $position.positionElements(element, popup, position, true);

      // params for making sure the node stays on-screen
      var horizontal = /^left/.test(position) || /^right/.test(position);
      var vertical = /^bottom/.test(position) || /^top/.test(position);
      var $body = angular.element($document[0].body);
      var $win = angular.element($window);
      var winWidth = Math.min($body.offsetWidth(), $win.offsetWidth());
      var winHeight = Math.max($body.offsetHeight(), $win.offsetHeight());
      var popupWidth = popup.offsetWidth();
      var popupHeight = popup.offsetHeight();
      var arrowOffsetAdjustment = 18;
      var arrowAdjustments = { x: 0, y: 0 };

      if (mousePosition) {
        var elBounds = element[0].getBoundingClientRect();
        if (vertical) {
          // top and bottom are horizontally centered
          popupPosition.left += mousePosition.pageX - (elBounds.left + elBounds.width / 2);
        } else if (position === 'right') {
          popupPosition.left -= elBounds.right - mousePosition.pageX;
        } else {
          popupPosition.left += mousePosition.pageX - elBounds.left;
        }
        if (horizontal) {
          // left and right are vertically centered
          popupPosition.top += mousePosition.pageY - (elBounds.top + elBounds.height / 2);
        } else if (position === 'top') {
          popupPosition.top -= elBounds.top - mousePosition.pageY;
        } else {
          popupPosition.top += elBounds.top - mousePosition.pageY;
        }
      }

      popupPosition['margin-left'] = null;
      popupPosition['margin-right'] = null;
      popupPosition['margin-top'] = null;
      popupPosition['margin-bottom'] = null;

      if (setMinWidth) {
        popupPosition['min-width'] = element.offsetWidth() + 'px';
      }

      // ensure we're not off the right edge
      if (popupPosition.left + popupWidth > winWidth - 2) {
        var finalLeft = winWidth - 2 - popupWidth;
        if (vertical && hasArrow) {
          arrowAdjustments.x = Math.min((popupWidth - arrowOffsetAdjustment) / 2, popupPosition.left - finalLeft);
        }
        popupPosition['margin-right'] = '0px';
        popupPosition.left = finalLeft;
      }
      // ensure we're not off the left edge (overrides right side)
      if (popupPosition.left < 2) {
        if (vertical && hasArrow) {
          arrowAdjustments.x = Math.max((arrowOffsetAdjustment - popupWidth) / 2, popupPosition.left - 2);
        }
        popupPosition['margin-left'] = '0px';
        popupPosition.left = 2;
      }
      // ensure we're not off the bottom edge
      if (popupPosition.top + popupHeight > winHeight - 2) {
        var finalTop = winHeight - 2 - popupHeight;
        if (horizontal && hasArrow) {
          arrowAdjustments.y = Math.min((popupHeight - arrowOffsetAdjustment) / 2, popupPosition.top - finalTop);
        }
        popupPosition['margin-top'] = '0px';
        popupPosition.top = finalTop;
      }
      // ensure we're not off the top edge (overrides bottom side)
      if (popupPosition.top < 2) {
        if (horizontal && hasArrow) {
          arrowAdjustments.y = Math.max((arrowOffsetAdjustment - popupHeight) / 2, popupPosition.top - 2);
        }
        popupPosition['margin-bottom'] = '0px';
        popupPosition.top = 2;
      }

      // final styling changes
      popupPosition.top += 'px';
      popupPosition.left += 'px';

      popup.css(popupPosition);
      // offset arrow if necessary
      if (hasArrow) {
        popup.querySelector('.arrow').css({
          transform: 'translate(' + arrowAdjustments.x + 'px, ' + arrowAdjustments.y + 'px)'
        });
      }
    }

    /**
     * Automatically positions the popup near the element, and watches to ensure it stays in place.
     *
     * @param $scope Scope for listening on
     * @param element Element to position around
     * @param popup Popup element
     * @param position position property
     * @param opts Options passed to the positionPopup function
     * @returns {function()} Deregistration function, only necessary if the popup is closed before the scope is destroyed
     */
    function autoPositionPopup($scope, element, popup, position, opts) {
      popup.css({ opacity: 0 });

      function setPosition() {
        $timeout(function () {
          positionPopup(element, popup, position, opts);
          popup.css({ opacity: null });
        }, 0, false);
      }

      setPosition();

      if (opts.mousePosition) {
        // only position once if we're using mouse position
        return angular.noop;
      }

      var scrollMonitor = scrollMonitorService.addListener(element.scrollableParent(), setPosition);
      var unlistenDestroy = $scope.$on('$destroy', function () {
        return scrollMonitor.destroy();
      });
      var unlistenWatch = $scope.$watch(setPosition);

      return function () {
        scrollMonitor.destroy();
        unlistenDestroy();
        unlistenWatch();
      };
    }

    function topOrBottom(el, estimatedHeight) {
      var position = 'bottom';
      // if within 200px (or 1/3) of the bottom, switch to top
      var elOffset = el.offset();
      var parent = el.scrollableParent();
      var parentOffset = parent.offset();
      var variance = Math.max(estimatedHeight || 0, Math.min(200, parentOffset.height / 3));
      if (elOffset.bottom - parent.scrollTop() > parentOffset.bottom - variance) {
        position = 'top';
      }
      return position;
    }

    return {
      autoPositionPopup: autoPositionPopup,
      positionPopup: positionPopup,
      topOrBottom: topOrBottom
    };
  }]);

  // This really doesn't do anything, but makes the import code more consistent;

  var ngAriaModule = 'ngAria';
  var ngSanitizeModule = 'ngSanitize';
  var ngAnimateModule = 'ngAnimate';

  var IS_MAC = window.navigator.userAgent.includes('Mac OS X');
  var IS_WINDOWS = window.navigator.userAgent.includes('Windows');

  var keycodesModule = angular.module('Q.constants.keycodes', []).constant('KeyCodes', {
    // Use $event.which === KeyCodes.KEY_NAME for correct matching
    BACKSPACE: 8,
    TAB: 9,
    ENTER: 13,
    RETURN: 13,
    SHIFT: 16,
    CTRL: 17,
    ALT: 18,
    ESC: 27,
    ESCAPE: 27,
    SPACE: 32,
    PAGE_UP: 33,
    PAGE_DOWN: 34,
    END: 35,
    HOME: 36,
    LEFT_ARROW: 37,
    UP_ARROW: 38,
    RIGHT_ARROW: 39,
    DOWN_ARROW: 40,
    INSERT: 45,
    DELETE: 46,
    COMMAND: 224,
    // some useful utility & display properties
    IS_MAC: IS_MAC,
    COMMAND_KEY: IS_MAC ? 'Cmd' : 'Ctrl',
    isCommand: function isCommand(event) {
      return !!event[IS_MAC ? 'metaKey' : 'ctrlKey'];
    },
    isShift: function isShift(event) {
      return !!event.shiftKey;
    },
    isAlt: function isAlt(event) {
      return !!event.altKey;
    },

    SYMBOLS: {
      COMMAND_KEY: IS_MAC ? '\u2318' : 'Ctrl',
      ALT_KEY: IS_MAC ? '\u2325' : 'Alt',
      CONTROL_KEY: IS_MAC ? '\u2303' : 'Ctrl',
      SHIFT_KEY: IS_MAC ? '\u21E7' : 'Shift',
      LEFT_ARROW: '\u2190',
      UP_ARROW_ARROW: '\u2190',
      RIGHT_ARROW: '\u2192',
      DOWN_ARROW: '\u2193',
      ENTER: IS_MAC ? '\u23CE' : 'Enter'
    }
  }).run(['$rootScope', 'KeyCodes', function ($rootScope, KeyCodes) {
    $rootScope.KeyCodes = KeyCodes;
  }]);

  var _compiledTemplate = void 0;
  var _compiledMenuTemplate = void 0;

  var bubbleDialogComponentModule = angular.module('Q.components.bubble-dialog', [ngSanitizeModule, positionHelperModule, scrollToComponentModule, keycodesModule])

  /**
   * @docType shared
   * @category service
   * @name Bubble-Dialog-Service
   * @description
   * A service that allows you to create a bubble dialog
   * @returns A factory object {object}
   */
  .factory('bubbleDialogService', ['$compile', '$rootScope', '$templateRequest', '$timeout', '$q', '$document', '$window', '$animate', 'positionHelper', 'scrollToElement', 'KeyCodes', function ($compile, $rootScope, $templateRequest, $timeout, $q, $document, $window, $animate, positionHelper, scrollToElement, KeyCodes) {
    /**
     * @parent Bubble-Dialog-Service
     * @name open
     * @description
     * A method that will open a bubble dialog on an element
     * @param scope {$rootScope.Scope} The angular scope to use for the bubble dialog's content (will be inherited)
     * @param {Object} el An element to position the bubble dialog relative to
     * @param {Object} opts A series of options that allow you configure the bubble dialog (title, content, buttons, position)
     * @param {string?} opts.content Optional content for the dialog (HTML OK) (req'd if no template)
     * @param {string?} opts.contentTemplate Optional content as template for the dialog (will be compiled)
     * @param {string?} opts.template Optional complete template for the dialog (must include all of the popover elements)
     * @param {string?} opts.menu Optional menu template for the dialog, which is used to render the bubble as a dropdown menu (handles layout, styling)
     * @param {string?} opts.position Optional text value indicating where to show the popup. Default is above or below based on how close `el` is to the window edge
     * @param {string?} opts.positionArrow If provided, use to center the tooltip
     * @param {boolean?} opts.closeable If true, then show a close button when hovering over the bubble
     * @param {string?} opts.title Optional title for the dialog
     * @param {string?} opts.className Optional class name to add to the dialog
     * @param {Array<Object>?} opts.buttons Optional buttons to append to the end
     * @param {number?} opts.delay If provided, delays showing the bubble for delay milliseconds
     * @param {number?} opts.estimatedHeight If provided, will be used to help determine default placement (top or bottom)
     * @param {Object?} opts.mousePosition If provided, anchors the bubble around this {pageX,pageY} point
     * @param {boolean?|string?} opts.autofocus If provided, enables focusing on the menu and keyboard navigation. If a string, used as the selector for the initial item
     * @returns {object} object representative of the bubble dialog instance just opened {object}
     */
    function open(scope, el, opts) {
      el = angular.element(el);
      var position = opts.position || positionHelper.topOrBottom(el, opts.estimatedHeight);
      var delayTimeout = null;
      var cancelDelayedRender = function cancelDelayedRender() {
        if (delayTimeout) {
          $timeout.cancel(delayTimeout);
          delayTimeout = null;
        }
      };

      var existingBubbleInstance = el.data('bubbleDialog');
      if (existingBubbleInstance && existingBubbleInstance.scope && !existingBubbleInstance.closed) {
        if (!opts.buttons && !opts.template && !opts.menu) {
          // just update scope
          existingBubbleInstance.scope.title = opts.title;
          existingBubbleInstance.scope.content = opts.content;
          existingBubbleInstance.scope.contentTemplate = opts.contentTemplate;
          existingBubbleInstance.scope.position = position;
          return existingBubbleInstance;
        } else {
          // destroy the existing bubble (can't have multiple on an element)
          existingBubbleInstance.closeImmediately();
        }
      }

      var bubbleScope = void 0;
      var bubbleEl = void 0;
      var stateChangeDereg = void 0;
      var scopeDereg = void 0;
      var deferred = $q.defer();

      var bubbleInstance = {
        scope: null,
        bubbleElement: null,
        target: el[0],
        showNow: function showNow() {
          if (!bubbleInstance.rendering) {
            renderBubble();
          }
        },
        close: function close() {
          bubbleInstance.closed = true;
          stateChangeDereg && stateChangeDereg();
          scopeDereg && scopeDereg();
          cancelDelayedRender();
          if (bubbleScope) {
            bubbleScope.remove();
          } else if (bubbleEl) {
            // ensure the node isn't stuck on screen for some reason
            bubbleEl.remove();
          }
          // remove from element
          el.data('bubbleDialog', null);
          deferred.reject('closed');
        },
        closeImmediately: function closeImmediately() {
          bubbleInstance.immediate = true;
          bubbleInstance.close();
        },

        result: deferred.promise
      };
      // never persist across page changes
      stateChangeDereg = scope.$on('$stateChangeStart', bubbleInstance.closeImmediately);
      scopeDereg = scope.$on('$destroy', bubbleInstance.closeImmediately);

      function setHandlers(enable) {
        var method = enable ? 'on' : 'off';
        bubbleEl[method]('click touchstart', stopBubbling);
        // Removed because it was causing unexpected behavior with tooltips nested inside links
        // Could not resolve the original reasoning behind stopping bubbling
        // el[method]("click touchstart", EventUtils.stopBubbling);
        $document[method]('keydown', escapeKeyDown);
        $document[method]('mousedown', escapeClick);
        // on mobile, these functions make sure we don't close on scroll (or long press) events
        $document[method]('touchstart', escapeTouchStart);
        $document[method]('touchend', escapeTouchEnd);
      }

      function isOutsideNode(event) {
        var target = event.target;
        var bubbleNode = bubbleInstance.bubbleElement;
        return target && bubbleNode && !bubbleNode[0].contains(target) && !el[0].contains(target);
      }

      function escapeKeyDown(event) {
        if (event.which === 27) {
          deferred.reject('escape key press');
        }
      }

      function escapeClick(event) {
        if (isOutsideNode(event)) {
          deferred.reject('user clicked elsewhere');
        }
      }

      var touchStartTime = -Infinity;

      function escapeTouchStart() {
        touchStartTime = Date.now();
      }

      function escapeTouchEnd(event) {
        if (Date.now() - touchStartTime < 150) {
          escapeClick(event);
        }
      }

      function renderBubble() {
        if (bubbleInstance.closed || !bubbleInstance.compiledTemplate) return;
        bubbleInstance.rendering = true;
        cancelDelayedRender();
        el.addClass('bubble-showing');

        bubbleInstance.scope = bubbleScope = scope.$new();
        bubbleScope.closeable = opts.closeable;
        bubbleScope.title = opts.title;
        bubbleScope.content = opts.content;
        bubbleScope.contentTemplate = opts.contentTemplate;
        bubbleScope.buttons = opts.buttons;
        bubbleScope.className = (opts.className || '') + (opts.title ? ' titled' : '');
        bubbleScope.menu = opts.menu;
        bubbleScope.position = position;
        bubbleScope.positionClass = position.split('-')[0] + ' ' + position;
        bubbleScope.removing = false;

        bubbleScope.remove = function () {
          if (bubbleScope.removing) return;
          el.removeClass('bubble-showing');

          bubbleScope.removing = true;

          if (bubbleEl) {
            setHandlers(false);
            bubbleScope.$applyAsync(function () {
              if (bubbleInstance.immediate) {
                bubbleEl.remove();
                bubbleScope.$destroy();
              } else {
                $animate.removeClass(bubbleEl, 'showing').then(function () {
                  bubbleEl.remove();
                  bubbleScope.$destroy();
                });
              }
            });
          } else {
            bubbleScope.$destroy();
          }
        };
        deferred.promise.finally(bubbleInstance.close);

        bubbleInstance.compiledTemplate(bubbleScope, function (_bubbleEl) {
          if (bubbleInstance.closed) return;

          bubbleInstance.bubbleElement = bubbleEl = _bubbleEl;

          var $body = angular.element($document[0].body);

          $body.append(bubbleEl);

          $window.requestAnimationFrame(function () {
            positionHelper.autoPositionPopup(bubbleScope, opts.positionArrow || el, bubbleEl, position, {
              hasArrow: true,
              mousePosition: opts.mousePosition
            });
          });

          if (opts.menu) {
            // auto close on click for menus
            bubbleEl.on('click', bubbleInstance.close);
          }

          $animate.addClass(bubbleEl, 'showing').then(function () {
            bubbleInstance.rendering = true;
            deferred.notify({
              ready: true,
              element: bubbleEl
            });
          });

          if (opts.autofocus) {
            // focuses in on the first selectable item
            // Note: this only works well if everything has an explicit `tabindex`
            var selector = angular.isString(opts.autofocus) ? opts.autofocus : '[tabindex]';
            $timeout(function () {
              bubbleEl.querySelector(selector).focus();
              scrollToElement({
                target: opts.positionArrow || el,
                ignoreIfVisible: true,
                center: true
              });

              // setup keystrokes
              bubbleEl.querySelectorAll('[tabindex]').on('keydown', function (event) {
                var target = event.target;
                if (!target || KeyCodes.isCommand(event) || KeyCodes.isShift(event) || KeyCodes.isAlt(event)) {
                  return;
                }
                var which = event.which;
                if (which === KeyCodes.ENTER) {
                  stopEvent(event);
                  angular.element(target).triggerHandler('click');
                } else if (which === KeyCodes.DOWN_ARROW || which === KeyCodes.UP_ARROW) {
                  var nodes = bubbleEl.querySelectorAll('[tabindex]');
                  var idx = Array.from(nodes).indexOf(target) + (which === KeyCodes.DOWN_ARROW ? 1 : -1);
                  var focusNode = nodes[idx];
                  if (focusNode && focusNode.focus) {
                    stopEvent(event);
                    focusNode.focus();
                  }
                }
              });
            }, 100, false);
          }

          setHandlers(true);
        });
      }

      function setupBubble() {
        delayTimeout = $timeout(renderBubble, opts.delay || 0);
      }

      var compiledTemplate = _compiledTemplate;
      if (opts.template) {
        compiledTemplate = $compile(opts.template);
      } else if (opts.menu) {
        if (!_compiledMenuTemplate) {
          _compiledMenuTemplate = $compile(bubbleDialogMenuTemplate);
        }
        compiledTemplate = _compiledMenuTemplate;
      }
      if (!compiledTemplate) {
        compiledTemplate = _compiledTemplate = $compile(bubbleDialogTemplate);
      }
      bubbleInstance.compiledTemplate = compiledTemplate;
      $timeout(setupBubble, 0);

      el.data('bubbleDialog', bubbleInstance);

      if (opts.buttons) {
        opts.buttons.forEach(function (button) {
          button.resolve = function ($event) {
            stopEvent($event);
            deferred.resolve(button.title);
          };
        });
      }

      return bubbleInstance;
    }

    return {
      open: open
    };
  }])
  /**
   * @ngdoc directive
   * @docType shared
   * @category directive
   * @name bubbleDialog
   * @restrict A
   * @element ANY
   * @description
   * Pops up a bubble dialog window with a message.
   *
   * @param {expression} bubbleDialog Message to show
   * @param {expression} bubbleDialogTemplate content as template to show (overrides content)
   * @param {template} bubbleDialogTitle Optional title
   * @param {template} bubbleDialogPosition Optional position argument
   *
   * @returns Directive Definition Object {object}
   */
  .directive('bubbleDialog', ['bubbleDialogService', function (bubbleDialogService) {
    var ACTIVE_CLASS = 'bubble-dialog-active';
    return {
      restrict: 'A',
      require: '?^tooltip',
      link: function link(scope, element, attrs, tooltipCtrl) {
        var instance = null;

        element.on('click', function (event) {
          stopEvent(event);

          if (instance && !instance.closed) {
            instance.close();
            instance = null;
            if (tooltipCtrl) tooltipCtrl.setDisabled(false);
            element.removeClass(ACTIVE_CLASS);
          } else {
            if (tooltipCtrl) tooltipCtrl.setDisabled(true);
            element.addClass(ACTIVE_CLASS);

            instance = bubbleDialogService.open(scope, element, {
              title: attrs.bubbleDialogTitle,
              content: scope.$eval(attrs.bubbleDialog),
              contentTemplate: scope.$eval(attrs.bubbleDialogTemplate),
              position: attrs.bubbleDialogPosition || undefined,
              className: 'bubble-dialog-simple ' + (attrs.bubbleDialogClassName || '')
            });
          }
        });
      }
    };
  }]);

  var tooltipComponentModule = angular.module('Q.components.tooltip', [bubbleDialogComponentModule])

  /**
   * @ngdoc directive
   * @name tooltip
   * @description
   * A popover tooltip shown on mouseover
   * @element ANY
   * @param {template} tooltip - Text of the tooltip
   * @param {template} alt - Text of the tooltip unless specified by {@param tooltip}
   * @param {template} tooltipPosition - Position of the tooltip
   * @param {template} tooltipDelay - Adjust how long to wait before showing, defaults to 600
   * @param {template} tooltipShortcutHint - If provided, show a shortcut key hint
   *
   * @example
   * <example>
   * <div class="btn btn-default" tooltip="Simple Tooltip">Hover me!</div>
   * </example>
   */
  .directive('tooltip', ['bubbleDialogService', '$document', '$sce', function (bubbleDialogService, $document, $sce) {
    var lastInstance = void 0;

    return {
      restrict: 'A',
      controller: function controller() {
        var ctrl = this;
        ctrl.instance = null;
        ctrl.disabled = false;
        ctrl.setDisabled = function (disabled) {
          ctrl.disabled = disabled;
          if (disabled && ctrl.instance) {
            ctrl.instance.close();
            ctrl.instance = null;
          }
        };
      },
      require: ['tooltip', '?tooltipHelpIcon'],
      link: function link(scope, element, attrs, _ref) {
        var _ref2 = slicedToArray(_ref, 2),
            tooltipCtrl = _ref2[0],
            tooltipHelpIconCtrl = _ref2[1];

        var getContent = function getContent() {
          return attrs.tooltip || attrs.alt;
        };

        var isOpen = tooltipCtrl.isOpen = function () {
          return getContent() && !tooltipCtrl.disabled && tooltipCtrl.instance && !tooltipCtrl.instance.closed;
        };

        var open = tooltipCtrl.open = function () {
          var delay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

          if (getContent() && !tooltipCtrl.disabled) {
            if (isOpen()) {
              if (delay === 0 && tooltipCtrl.instance && lastInstance === tooltipCtrl.instance) {
                tooltipCtrl.instance.showNow();
              }
            } else {
              if (lastInstance) {
                scope.$applyAsync(lastInstance.close);
              }
              var content = getContent();
              if (attrs.tooltipShortcutHint) {
                content = $sce.trustAsHtml('<span class="tooltip-shortcut"><span>' + content + '</span><span class="shortcut-hint">' + attrs.tooltipShortcutHint + '</span></span>');
              }
              tooltipCtrl.instance = lastInstance = bubbleDialogService.open(scope, element, {
                closeable: true,
                content: content,
                position: attrs.tooltipPosition,
                positionArrow: tooltipCtrl.helpIconElement,
                className: 'tooltip',
                delay: delay
              });
            }
          }
        };

        var close = tooltipCtrl.close = function () {
          if (tooltipCtrl.instance) {
            tooltipCtrl.instance.close();
            tooltipCtrl.instance = null;
          }
        };

        tooltipCtrl.toggle = function () {
          var delay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

          if (isOpen()) {
            close();
          } else {
            open(delay);
          }
        };

        var delay = function delay() {
          return +(attrs.tooltipDelay || (tooltipHelpIconCtrl ? 0 : 600));
        };

        element.on('mouseenter', function () {
          return open(delay());
        }).on('mouseleave', close);

        scope.$on('$destroy', close);
      }
    };
  }])

  // A simple component that renders a question mark in a circle, which can be used for highlighting a tooltip
  // If added below a tooltip, it enables that tooltip to be opened explicitly by clicking
  // It can also be used as the source of a tooltip (with the same click-to-show behavior)
  .component('tooltipHelpIcon', {
    require: {
      tooltipCtrl: '^tooltip'
    },
    template: '',
    controller: ['$element', '$scope', function controller($element, $scope) {
      var ctrl = this;
      ctrl.$onInit = function () {
        ctrl.tooltipCtrl.helpIconElement = $element;
      };
      $element.on('mouseenter', function (event) {
        if ($element.attr('tooltip')) return;
        stopEvent(event);
        $scope.$applyAsync(function () {
          return ctrl.tooltipCtrl.open();
        });
      });
      $element.on('click', function (event) {
        stopEvent(event);
        $scope.$applyAsync(function () {
          return ctrl.tooltipCtrl.toggle();
        });
      });
    }]
  }).directive('dropdownToggle', function () {
    return {
      restrict: 'A',
      require: ['?^dropdown', '?^tooltip'],
      link: function link(scope, el, attr, _ref3) {
        var _ref4 = slicedToArray(_ref3, 2),
            dropdownCtrl = _ref4[0],
            tooltipCtrl = _ref4[1];

        if (dropdownCtrl && tooltipCtrl) {
          scope.$watch(function () {
            return dropdownCtrl.isOpen();
          }, tooltipCtrl.setDisabled);
        }
      }
    };
  });

  var stickyHeaderComponentModule = angular.module('Q.components.sticky-header', [scrollMonitorServiceModule]).directive('stickyHeader', ['scrollMonitorService', '$timeout', '$window', function (scrollMonitorService, $timeout, $window) {
    return {
      restrict: 'A',
      link: function link(scope, $elem, attr) {
        if (attr.stickyHeaderNonMobile !== undefined && angular.element($window).offsetWidth() < 768) {
          return;
        }
        $timeout(function () {
          // create clone of the element to act as a placeholder when we scroll off-screen
          var elem = $elem[0];
          var $placeholder = $elem.clone();
          var placeholder = $placeholder[0];
          $placeholder.addClass('sticky-header-placeholder-inactive');
          $elem.addClass('sticky-header');
          $elem.after($placeholder);

          var viewport = attr.stickyHeader || $elem.scrollableParent();

          var lastTop = null;
          var lastLeft = null;
          var lastActive = false;

          var isTable = elem.nodeName === 'THEAD' || elem.nodeName === 'TR';

          var scrollWatcher = scrollMonitorService.addListener(viewport, function (event, data) {
            var nonScrollEvent = event && event.type !== 'scroll';
            var elTop = data.elementTop;
            if (lastActive) {
              // the element top won't be useful if we were already active
              if (nonScrollEvent) {
                // if we've had a DOM change, lastTop may no longer be correct
                elTop = $placeholder.offsetTop() - $placeholder.scrollableParent().offsetTop();
              } else {
                // otherwise, if just scrolling, we can safely use the last known top
                elTop = lastTop;
              }
            }
            var elLeft = lastActive ? lastLeft : $elem.offsetLeft();
            var active = data.viewportScrollTop >= elTop;
            var shouldUpdate = lastActive !== active;

            // toggle classes if we're changing state
            if (shouldUpdate) {
              $elem.toggleClass('sticky-header-active', active);
              $placeholder.toggleClass('sticky-header-placeholder-inactive', !active);
              $placeholder.toggleClass('sticky-header-placeholder-active', active);

              $elem.css('top', active ? data.viewportTop + 'px' : null);
              $elem.css('left', active ? elLeft + 'px' : null);
              $elem.css('margin-top', active ? '0' : null);
            }
            if (shouldUpdate || active) {
              if (attr.stickyHeaderSetWidth !== 'false') {
                $elem.css('width', active ? placeholder.offsetWidth + 'px' : null);
              }
              if (attr.stickyHeaderSetHeight !== 'false') {
                $elem.css('height', active ? placeholder.offsetHeight + 'px' : null);
              }
            }

            // update table cells everytime if active, or if changing states
            if (isTable && (shouldUpdate || active)) {
              var origCells = elem.querySelectorAll('td,th');
              var phCells = placeholder.querySelectorAll('td,th');
              angular.forEach(phCells, function (cell, idx) {
                var width = active ? cell.offsetWidth + 'px' : null;
                var height = active ? cell.offsetHeight + 'px' : null;
                angular.element(origCells[idx]).css('min-width', width);
                angular.element(origCells[idx]).css('min-height', height);
              });
            }

            lastActive = active;
            lastTop = elTop;
            lastLeft = elLeft;
          }, $elem);

          scope.$on('$destroy', function () {
            return scrollWatcher.destroy();
          });
        }, 250);
      }
    };
  }]);

  var consentCookiePopupTemplate = "<div class=\"help-block\"> <p> This website stores data such as cookies to enable important site functionality, including analytics and personalization. </p> <p><a href=\"/kb/legal/privacy-policy\">Read our privacy policy here.</a></p> </div> <div class=\"buttons\"> <button class=\"btn-primary btn-sm\" ng-click=\"consent()\">Accept</button> </div> ";

  var CONSENT_COOKIE = 'qualified-cookie-consent';

  var cookieWarningServiceModule = angular.module('Q.services.cookie-warning-service', ['ngAnimate']).directive('consentCookiePopup', ['$animate', function ($animate) {
    return {
      restrict: 'E',
      template: consentCookiePopupTemplate,
      link: function link(scope, elem) {
        scope.consent = function () {
          setCookie(CONSENT_COOKIE, 1, Infinity);
          $animate.leave(elem);
          scope.$destroy();
        };
      }
    };
  }]).run(['$compile', '$rootScope', '$animate', '$document', function ($compile, $rootScope, $animate, $document) {
    if (!hasCookie(CONSENT_COOKIE)) {
      var el = angular.element('<consent-cookie-popup></consent-cookie-popup>');
      $compile(el)($rootScope.$new(true));
      $animate.enter(el, $document.find('body'));
    }
  }]);

  var kbRedirectTemplate = "<h1>Please Wait</h1> <p> Redirecting you to our <a href=\"{{$ctrl.href}}\">new reference documentation</a>. </p> ";

  var articleMap = [[/^assess\/advanced-challenge-ide\/?$/, 'for-candidates/advanced-challenge-ide/challenge-ide'], [/^assess\/challenge-solver\/?$/, 'for-candidates/challenge-solver/challenge-ide'], [/^assess(\/.*)?$/, 'for-candidates$1'], [/^hire\/account-team(\/.*)?$/, 'reference/account/account-team$1'], [/^hire\/(assessments|candidates|challenges)(\/.*)?$/, 'reference/features/$1$2'], [/^hire\/tips(.*)$/, 'for-teams/reviewing'], [/^hire\/account(\/.*)?$/, 'reference/account/account'], [/^hire\/embed$/, 'integrations/custom-integrations/embed'], [/^hire\/invite$/, 'for-teams/process/invitations'], [/^hire\/live-interview$/, 'for-teams/process/interact'], [/^hire\/setup$/, 'for-teams/getting-started/setup'], [/^hire(\/?.*)$/, 'for-teams'], [/^general(\/?.*)$/, 'reference$1'], [/^integrations(\/?.*)$/, 'integrations'], // don't try to line these up
  [/^languages(\/?.*)$/, 'reference/languages$1'], [/^changes(\/?.*)$/, 'changes']];

  var kbRedirectComponentModule = angular.module('Q.components.kb-redirect', []).component('kbRedirect', {
    controller: 'KbRedirectCtrl',
    template: kbRedirectTemplate
  }).controller('KbRedirectCtrl', ['$window', '$timeout', function KbRedirectCtrl($window, $timeout) {
    var ctrl = this;

    ctrl.$onInit = function () {
      var path = ($window.location.pathname || '').replace(/^\/?kb\//, '');
      var newPath = '';
      articleMap.some(function (_ref) {
        var _ref2 = slicedToArray(_ref, 2),
            test = _ref2[0],
            result = _ref2[1];

        if (test.test(path)) {
          newPath = path.replace(test, result).replace(/_/g, '-');
          return true;
        }
      });
      ctrl.href = appConfig.docsUrl + '/' + newPath;
      $timeout(function () {
        $window.location = ctrl.href;
      });
    };
  }]);

  angular.module('qualified', [
  // general includes
  ngAriaModule, ngSanitizeModule, ngAnimateModule, loadingBarModule,

  // configuration modules
  configModule,

  // remote exception handling
  exceptionHandlerServiceModule,

  // modules in use on the kb
  activateOnScrollComponentModule, scrollToComponentModule, tooltipComponentModule, stickyHeaderComponentModule, cookieWarningServiceModule, kbRedirectComponentModule,

  // analytics
  trackerServiceModule]).config(['$locationProvider', function ($locationProvider) {
    // we set the base tag _within_ the angular app, because it breaks regular links
    var base = document.createElement('base');
    base.href = window.config.kbRoute + '/';
    document.getElementsByTagName('head')[0].appendChild(base);

    $locationProvider.html5Mode(true);
  }]).run(['$document', function ($document) {
    angular.forEach($document[0].querySelectorAll('a'), function (a) {
      var $a = angular.element(a);
      if (/^[#]/.test($a.attr('href'))) {
        // add in scroll-to links for in-page references
        $a.attr('scroll-to', '');
      } else if (!a.target) {
        // force page reloads for everything else
        a.target = '_self';
      }
    });
  }]).controller('KbAppCtrl', function () {});

}());
